import i18n from './i18n';

// OPT451-FE: In production, FR/NL/PL/IT/ES resource bundles are loaded on demand
// via i18next-http-backend (see src/i18n.ts). To avoid pulling the ~32 k LOC of
// those addon .ts files into the production JS bundle, we only re-import them
// in dev/test where they synchronously seed i18n for tests and hot reload.
if (!import.meta.env.PROD) {
  await Promise.all([
    import('./i18nAddonFR_NL'),
    import('./i18nAddonPL_IT_ES'),
    import('./i18nAddonP3_FR_NL'),
    import('./i18nAddonP3_PL_IT_ES'),
  ]);
}

const deResources = {
  landing: {
    heroTitleStart: 'Ihr Umzug.',
    heroTitleHighlight: 'Unser Service.',
    heroSubtitle:
      'Vergleichen Sie kostenlos professionelle Umzugsfirmen in Ihrer Region. Erhalten Sie bis zu 15 Angebote und sparen Sie Zeit und Geld.',
    heroCtaPrimary: 'Jetzt Angebote erhalten',
    heroCtaSecondary: 'Anmelden',
    trustBadgeFree: '100% Kostenlos',
    trustBadgeVerified: 'Geprüfte Firmen',
    trustBadgeGdpr: 'DSGVO-konform',
    featuresTitle: 'Warum regionalumzug24?',
    featuresSubtitle: 'Wir verbinden Sie mit den besten Umzugsfirmen in Ihrer Region',
    featureMatchingTitle: 'Intelligentes Matching',
    featureMatchingDesc:
      'Unser System findet automatisch die perfekten Umzugsfirmen für Ihre Anforderungen',
    featureVerifiedTitle: 'Verifizierte Firmen',
    featureVerifiedDesc: 'Alle Umzugsunternehmen werden von uns geprüft und verifiziert',
    featureReviewsTitle: 'Bewertungssystem',
    featureReviewsDesc: 'Profitieren Sie von echten Kundenbewertungen und Erfahrungen',
    featureFastTitle: 'Schnelle Antworten',
    featureFastDesc: 'Erhalten Sie Angebote innerhalb von 24 Stunden',
    featureTransparentTitle: 'Transparente Preise',
    featureTransparentDesc: 'Vergleichen Sie Preise und Leistungen ganz einfach',
    featureFreeTitle: '100% Kostenlos',
    featureFreeDesc: 'Unsere Plattform ist für Kunden komplett kostenfrei',
    howItWorksTitle: "So funktioniert's",
    howItWorksSubtitle: 'In nur 3 einfachen Schritten zum besten Umzugsangebot',
    step1Title: 'Anfrage stellen',
    step1Desc: 'Beschreiben Sie Ihren Umzug in wenigen Schritten',
    step2Title: 'Angebote erhalten',
    step2Desc: 'Passende Umzugsfirmen senden Ihnen ihre Angebote',
    step3Title: 'Firma wählen',
    step3Desc: 'Vergleichen Sie und wählen Sie das beste Angebot',
    howItWorksCta: 'Jetzt kostenlos starten',
    ctaTitle: 'Bereit für Ihren stressfreien Umzug?',
    ctaSubtitle:
      'Starten Sie jetzt und erhalten Sie kostenlose Angebote von geprüften Umzugsfirmen',
    ctaPrimary: 'Angebote erhalten',
    ctaSecondary: 'Anmelden',
    footerBrand: 'regionalumzug24',
    footerTagline: 'Ihr Partner für professionelle Umzugsservices in Deutschland',
    footerCustomersHeading: 'Für Kunden',
    footerCustomersRequest: 'Anfrage stellen',
    footerCustomersLogin: 'Login',
    footerCompaniesHeading: 'Für Firmen',
    footerCompaniesRegister: 'Registrieren',
    footerCompaniesLogin: 'Login',
    footerLegalHeading: 'Rechtliches',
    footerImprint: 'Impressum',
    footerPrivacy: 'Datenschutz',
    footerTerms: 'AGB',
    footerCopyright: '© 2025 regionalumzug24. Alle Rechte vorbehalten.',
  },
  berlinLanding: {
    metaTitle: 'Umzug Berlin | RegionalUmzug24 - Umzugsfirmen vergleichen',
    metaDescription:
      'Finde die besten Umzugsfirmen in Berlin. Kostenlos Angebote von verifizierten Berliner Umzugsunternehmen vergleichen. Geprüft, Bewertet, DSGVO-konform.',
    metaKeywords:
      'Umzug Berlin, Umzugsfirmen Berlin, Umzugskosten Berlin, Umzugsunternehmen Berlin',
    benefitsTitle: 'Deine Vorteile mit RegionalUmzug24 in Berlin',
    benefitsSubtitle: 'Warum sich tausende Berliner für unsere Vermittlungsplattform entscheiden',
    benefitFreeTitle: '100 % kostenlos',
    benefitFreeDesc:
      'Die Anfrage und der Vergleich sind für dich komplett kostenfrei und unverbindlich.',
    benefitLocalTitle: 'Lokale Berliner Firmen',
    benefitLocalDesc:
      'Wir vermitteln ausschließlich geprüfte Umzugsfirmen mit Service in Berlin und Umland (PLZ 10-14).',
    benefitReviewsTitle: 'Echte Bewertungen',
    benefitReviewsDesc:
      'Lies verifizierte Kundenbewertungen und entscheide dich auf Basis echter Erfahrungen.',
    statsTitle: 'Umzug in Berlin in Zahlen',
    statsSubtitle: 'Vertrauen Berliner Kund:innen auf RegionalUmzug24',
    statFirms: '200+',
    statFirmsLabel: 'Berliner Umzugsfirmen',
    statMoves: '500+',
    statMovesLabel: 'Vermittelte Umzüge',
    statSavings: '40 %',
    statSavingsLabel: 'Durchschn. Ersparnis',
    statRating: '4,7/5',
    statRatingLabel: 'Kundenbewertung',
    ctaTitle: 'Bereit für deinen Umzug in Berlin?',
    ctaSubtitle:
      'Erstelle jetzt kostenlos deine Anfrage und erhalte Angebote von geprüften Berliner Umzugsfirmen.',
    ctaPrimary: 'Jetzt Anfrage erstellen',
    ctaSecondary: 'Firmen in Berlin ansehen',
  },
  berlinDirectory: {
    metaTitle: 'Umzugsfirmen Berlin | RegionalUmzug24 - Berliner Firmen vergleichen',
    metaDescription:
      'Liste geprüfter Umzugsfirmen in Berlin. Vergleiche Bewertungen, Spezialgebiete und Preise von Berliner Umzugsunternehmen im PLZ-Bereich 10-14.',
    metaKeywords:
      'Umzugsfirmen Berlin, Umzugsunternehmen Berlin, Berliner Umzugsfirma, Umzug Berlin Firmen',
    pageTitle: 'Umzugsfirmen in Berlin',
    pageSubtitle:
      'Entdecke geprüfte Berliner Umzugsfirmen mit echten Bewertungen. PLZ-Bereich 10-14 - inklusive Potsdam und Brandenburg.',
    filterTitle: 'Filter',
    filterPremium: 'Nur Premium-Firmen',
    filterVerified: 'Nur verifizierte Firmen',
    filterPostalTitle: 'PLZ-Bereich',
    sortTitle: 'Sortierung',
    sortRating: 'Beste Bewertung',
    sortOrders: 'Meiste Aufträge',
    sortNewest: 'Neueste',
    resultCount: '{{count}} Firmen gefunden',
    emptyTitle: 'Keine Firmen gefunden',
    emptyDescription:
      'Mit den aktuellen Filtern wurden keine Berliner Umzugsfirmen gefunden. Versuche, die Filter anzupassen.',
    emptyReset: 'Filter zurücksetzen',
    loadingTitle: 'Lade Berliner Umzugsfirmen...',
    errorTitle: 'Fehler beim Laden',
    errorDescription:
      'Die Liste der Berliner Umzugsfirmen konnte nicht geladen werden. Bitte versuche es erneut.',
    errorRetry: 'Erneut versuchen',
    companyVerified: 'Verifiziert',
    companyPremium: 'Premium',
    companyReviews: 'Bewertungen',
    companySpecialties: 'Spezialgebiete',
    companyServiceArea: 'Servicegebiet',
    companyViewProfile: 'Profil ansehen',
    companyRequestQuote: 'Angebot anfragen',
    paginationPrev: 'Zurück',
    paginationNext: 'Weiter',
    paginationPage: 'Seite {{page}} von {{total}}',
  },
  hamburgLanding: {
    metaTitle: 'Umzug Hamburg | RegionalUmzug24 - Umzugsfirmen vergleichen',
    metaDescription:
      'Finde die besten Umzugsfirmen in Hamburg. Kostenlos Angebote von verifizierten Hamburger Umzugsunternehmen vergleichen. Hafenkenntnisse, Elb-Logistik.',
    metaKeywords:
      'Umzug Hamburg, Umzugsfirmen Hamburg, Umzugskosten Hamburg, Umzugsunternehmen Hamburg',
    heroTitleStart: 'Ihr Umzug in',
    heroTitleHighlight: 'Hamburg.',
    heroSubtitle:
      'Vergleichen Sie kostenlos geprüfte Hamburger Umzugsfirmen mit Erfahrung für Hafen, Speicherstadt und Elbüberquerungen.',
    heroCtaPrimary: 'Jetzt Angebote erhalten',
    heroCtaSecondary: 'Hamburger Firmen ansehen',
    heroStatFirms: '180+ Hamburger Firmen',
    heroStatMoves: '450+ vermittelte Umzüge',
    heroStatRating: '4,7/5 Bewertung',
    benefitsTitle: 'Deine Vorteile mit RegionalUmzug24 in Hamburg',
    benefitsSubtitle:
      'Warum sich Hamburger Kund:innen für unsere Vermittlungsplattform entscheiden',
    benefitFreeTitle: '100 % kostenlos',
    benefitFreeDesc:
      'Die Anfrage und der Vergleich sind für dich komplett kostenfrei und unverbindlich.',
    benefitLocalTitle: 'Lokale Hamburger Firmen',
    benefitLocalDesc:
      'Wir vermitteln ausschließlich geprüfte Umzugsfirmen mit Service in Hamburg und Umland (PLZ 20-22).',
    benefitReviewsTitle: 'Echte Bewertungen',
    benefitReviewsDesc:
      'Lies verifizierte Kundenbewertungen und entscheide dich auf Basis echter Erfahrungen.',
    statsTitle: 'Umzug in Hamburg in Zahlen',
    statsSubtitle: 'Vertrauen Hamburger Kund:innen auf RegionalUmzug24',
    statFirms: '180+',
    statFirmsLabel: 'Hamburger Umzugsfirmen',
    statMoves: '450+',
    statMovesLabel: 'Vermittelte Umzüge',
    statSavings: '35 %',
    statSavingsLabel: 'Durchschn. Ersparnis',
    statRating: '4,7/5',
    statRatingLabel: 'Kundenbewertung',
    processTitle: 'So läuft Ihr Umzug in Hamburg ab',
    processSubtitle: 'In drei einfachen Schritten zu Ihrem Wunschumzug in der Hansestadt',
    step1Title: 'Anfrage stellen',
    step1Desc: 'Beschreiben Sie Ihren Hamburger Umzug in wenigen Schritten online.',
    step2Title: 'Hamburger Firmen erhalten',
    step2Desc:
      'Passende Umzugsfirmen aus der Hansestadt senden Ihnen ihre Angebote – auch Hafenkonzern erfahren.',
    step3Title: 'Firma wählen',
    step3Desc: 'Vergleichen Sie Bewertungen und wählen Sie das beste Angebot für Ihren Umzug.',
    trustTitle: 'Geprüfte Hamburger Umzugsfirmen',
    trustSubtitle: 'Sicherheit und Qualität – speziell für die Hansestadt',
    trustVerifiedTitle: 'Verifizierte Hamburger Firmen',
    trustVerifiedDesc:
      'Jede Umzugsfirma wird auf Gewerbeanmeldung, Versicherung und Hafenerfahrung geprüft.',
    trustGdprTitle: 'DSGVO-konform',
    trustGdprDesc: 'Ihre Daten werden verschlüsselt übertragen und nicht an Dritte weitergegeben.',
    trustFreeTitle: '100 % kostenlos',
    trustFreeDesc:
      'Die Nutzung von RegionalUmzug24 ist für Sie komplett kostenfrei – ohne versteckte Gebühren.',
    faqTitle: 'Häufige Fragen zum Umzug in Hamburg',
    faqSubtitle: 'Antworten auf die wichtigsten Fragen rund um Hamburger Umzüge',
    faq1Question: 'Was kostet ein Umzug in Hamburg?',
    faq1Answer:
      'Die Kosten für einen Umzug in Hamburg hängen von Wohnfläche, Etage und Entfernung ab. Ein 3-Zimmer-Umzug innerhalb Hamburgs liegt meist zwischen 800 und 1.600 Euro.',
    faq2Question: 'Wie finde ich eine seriöse Umzugsfirma in Hamburg?',
    faq2Answer:
      'Achten Sie auf verifizierte Bewertungen, eine Hamburger Gewerbeanmeldung und Erfahrung mit der Elbüberquerung sowie Halteverbotszonen.',
    faq3Question: 'Werden Halteverbotszonen in Hamburg eingerichtet?',
    faq3Answer:
      'Ja, viele Hamburger Stadtteile erfordern eine Halteverbotszone. Unsere Partnerfirmen kümmern sich auf Wunsch um Beantragung und Aufstellung.',
    faq4Question: 'Wie lange dauert ein Umzug in Hamburg?',
    faq4Answer:
      'Ein typischer Hamburger 3-Zimmer-Umzug dauert zwischen vier und acht Stunden, je nach Stockwerk, Entfernung und Verkehrslage.',
    faq5Question: 'Können meine Möbel über die Elbe transportiert werden?',
    faq5Answer:
      'Ja, geprüfte Hamburger Umzugsfirmen kennen die Strecken über die Elbbrücken und organisieren Umzüge in alle Stadtteile nördlich und südlich der Elbe.',
    ctaTitle: 'Bereit für deinen Umzug in Hamburg?',
    ctaSubtitle:
      'Erstelle jetzt kostenlos deine Anfrage und erhalte Angebote von geprüften Hamburger Umzugsfirmen.',
    ctaPrimary: 'Jetzt Anfrage erstellen',
    ctaSecondary: 'Hamburger Firmen ansehen',
  },
  hamburgDirectory: {
    metaTitle: 'Umzugsfirmen Hamburg | RegionalUmzug24 - Hamburger Firmen vergleichen',
    metaDescription:
      'Liste geprüfter Umzugsfirmen in Hamburg. Vergleiche Bewertungen, Spezialgebiete und Preise von Hamburger Umzugsunternehmen im PLZ-Bereich 20-22.',
    metaKeywords:
      'Umzugsfirmen Hamburg, Umzugsunternehmen Hamburg, Hamburger Umzugsfirma, Umzug Hamburg Firmen',
    pageTitle: 'Umzugsfirmen in Hamburg',
    pageSubtitle:
      'Entdecke geprüfte Hamburger Umzugsfirmen mit echten Bewertungen. PLZ-Bereich 20-22 – von der Innenstadt bis Bergedorf.',
    filterTitle: 'Filter',
    filterPremium: 'Nur Premium-Firmen',
    filterVerified: 'Nur verifizierte Firmen',
    filterPostalTitle: 'PLZ-Bereich',
    filterPostalAll: 'Alle PLZ-Bereiche',
    filterPostal20: 'PLZ 20 (Innenstadt)',
    filterPostal21: 'PLZ 21 (Norden)',
    filterPostal22: 'PLZ 22 (Osten)',
    sortTitle: 'Sortierung',
    sortRating: 'Beste Bewertung',
    sortOrders: 'Meiste Aufträge',
    sortNewest: 'Neueste',
    resultCount: '{{count}} Firmen gefunden',
    emptyTitle: 'Keine Firmen gefunden',
    emptyDescription:
      'Mit den aktuellen Filtern wurden keine Hamburger Umzugsfirmen gefunden. Versuche, die Filter anzupassen.',
    emptyReset: 'Filter zurücksetzen',
    loadingTitle: 'Lade Hamburger Umzugsfirmen...',
    errorTitle: 'Fehler beim Laden',
    errorDescription:
      'Die Liste der Hamburger Umzugsfirmen konnte nicht geladen werden. Bitte versuche es erneut.',
    errorRetry: 'Erneut versuchen',
    paginationPrev: 'Zurück',
    paginationNext: 'Weiter',
    paginationPage: 'Seite {{page}} von {{total}}',
  },
  muenchenLanding: {
    metaTitle: 'Umzug München | RegionalUmzug24 - Umzugsfirmen vergleichen',
    metaDescription:
      'Finde die besten Umzugsfirmen in München. Kostenlos Angebote von verifizierten Münchner Umzugsunternehmen vergleichen. Diskret, sicher, DSGVO-konform.',
    metaKeywords:
      'Umzug München, Umzugsfirmen München, Umzugskosten München, Umzugsunternehmen München',
    heroTitleStart: 'Ihr Umzug in',
    heroTitleHighlight: 'München.',
    heroSubtitle:
      'Vergleichen Sie kostenlos geprüfte Münchner Umzugsfirmen – vom Altbau in Maxvorstadt bis zum Familienheim im Umland.',
    heroCtaPrimary: 'Jetzt Angebote erhalten',
    heroCtaSecondary: 'Münchner Firmen ansehen',
    heroStatFirms: '170+ Münchner Firmen',
    heroStatMoves: '420+ vermittelte Umzüge',
    heroStatRating: '4,8/5 Bewertung',
    benefitsTitle: 'Deine Vorteile mit RegionalUmzug24 in München',
    benefitsSubtitle: 'Warum sich Münchner Kund:innen für unsere Plattform entscheiden',
    benefitFreeTitle: '100 % kostenlos',
    benefitFreeDesc:
      'Die Anfrage und der Vergleich sind für dich komplett kostenfrei und unverbindlich.',
    benefitLocalTitle: 'Lokale Münchner Firmen',
    benefitLocalDesc:
      'Wir vermitteln ausschließlich geprüfte Umzugsfirmen mit Service in München und Umland (PLZ 80-81).',
    benefitReviewsTitle: 'Echte Bewertungen',
    benefitReviewsDesc:
      'Lies verifizierte Kundenbewertungen und entscheide dich auf Basis echter Erfahrungen.',
    statsTitle: 'Umzug in München in Zahlen',
    statsSubtitle: 'Münchner Kund:innen vertrauen auf RegionalUmzug24',
    statFirms: '170+',
    statFirmsLabel: 'Münchner Umzugsfirmen',
    statMoves: '420+',
    statMovesLabel: 'Vermittelte Umzüge',
    statSavings: '38 %',
    statSavingsLabel: 'Durchschn. Ersparnis',
    statRating: '4,8/5',
    statRatingLabel: 'Kundenbewertung',
    processTitle: 'So läuft Ihr Umzug in München ab',
    processSubtitle:
      'In drei einfachen Schritten zu Ihrem Wunschumzug in der bayerischen Landeshauptstadt',
    step1Title: 'Anfrage stellen',
    step1Desc:
      'Beschreiben Sie Ihren Münchner Umzug in wenigen Schritten – auch Altbau und Parkplatzsituation.',
    step2Title: 'Münchner Firmen erhalten',
    step2Desc:
      'Passende Münchner Umzugsfirmen senden Ihnen ihre Angebote – diskret auch in Schwabing.',
    step3Title: 'Firma wählen',
    step3Desc:
      'Vergleichen Sie Bewertungen und wählen Sie die passende Firma für Ihren Münchner Umzug.',
    trustTitle: 'Geprüfte Münchner Umzugsfirmen',
    trustSubtitle: 'Sicherheit und Qualität – speziell für die Landeshauptstadt',
    trustVerifiedTitle: 'Verifizierte Münchner Firmen',
    trustVerifiedDesc:
      'Jede Umzugsfirma wird auf Gewerbeanmeldung, Versicherung und Erfahrung in Münchner Altbauten geprüft.',
    trustGdprTitle: 'DSGVO-konform',
    trustGdprDesc: 'Ihre Daten werden verschlüsselt übertragen und nicht an Dritte weitergegeben.',
    trustFreeTitle: '100 % kostenlos',
    trustFreeDesc:
      'Die Nutzung von RegionalUmzug24 ist für Sie komplett kostenfrei – ohne versteckte Gebühren.',
    faqTitle: 'Häufige Fragen zum Umzug in München',
    faqSubtitle: 'Antworten auf die wichtigsten Fragen rund um Münchner Umzüge',
    faq1Question: 'Was kostet ein Umzug in München?',
    faq1Answer:
      'Die Kosten für einen Münchner Umzug hängen von Wohnfläche, Stockwerk und Parkplatzsituation ab. Ein 3-Zimmer-Umzug innerhalb Münchens kostet meist 900 bis 1.800 Euro.',
    faq2Question: 'Wie finde ich eine seriöse Umzugsfirma in München?',
    faq2Answer:
      'Achten Sie auf verifizierte Bewertungen, Erfahrung mit Münchner Altbauten und die Fähigkeit, Halteverbotszonen zu beantragen.',
    faq3Question: 'Werden Halteverbotszonen in München eingerichtet?',
    faq3Answer:
      'Ja, gerade in Maxvorstadt und Schwabing sind Halteverbotszonen oft unverzichtbar. Unsere Partner kümmern sich auf Wunsch darum.',
    faq4Question: 'Wie lange dauert ein Umzug in München?',
    faq4Answer:
      'Ein 3-Zimmer-Umzug innerhalb Münchens dauert zwischen fünf und neun Stunden, abhängig von Stockwerk und Verkehr.',
    faq5Question: 'Können auch Fernumzüge ab München organisiert werden?',
    faq5Answer:
      'Ja, geprüfte Münchner Umzugsfirmen bieten auch bayernweite und deutschlandweite Umzüge ab München an.',
    ctaTitle: 'Bereit für deinen Umzug in München?',
    ctaSubtitle:
      'Erstelle jetzt kostenlos deine Anfrage und erhalte Angebote von geprüften Münchner Umzugsfirmen.',
    ctaPrimary: 'Jetzt Anfrage erstellen',
    ctaSecondary: 'Münchner Firmen ansehen',
  },
  muenchenDirectory: {
    metaTitle: 'Umzugsfirmen München | RegionalUmzug24 - Münchner Firmen vergleichen',
    metaDescription:
      'Liste geprüfter Umzugsfirmen in München. Vergleiche Bewertungen, Spezialgebiete und Preise von Münchner Umzugsunternehmen im PLZ-Bereich 80-81.',
    metaKeywords:
      'Umzugsfirmen München, Umzugsunternehmen München, Münchner Umzugsfirma, Umzug München Firmen',
    pageTitle: 'Umzugsfirmen in München',
    pageSubtitle:
      'Entdecke geprüfte Münchner Umzugsfirmen mit echten Bewertungen. PLZ-Bereich 80-81 – von der Altstadt bis ins Münchner Umland.',
    filterTitle: 'Filter',
    filterPremium: 'Nur Premium-Firmen',
    filterVerified: 'Nur verifizierte Firmen',
    filterPostalTitle: 'PLZ-Bereich',
    filterPostalAll: 'Alle PLZ-Bereiche',
    filterPostal80: 'PLZ 80 (Innenstadt)',
    filterPostal81: 'PLZ 81 (Süd/Ost)',
    sortTitle: 'Sortierung',
    sortRating: 'Beste Bewertung',
    sortOrders: 'Meiste Aufträge',
    sortNewest: 'Neueste',
    resultCount: '{{count}} Firmen gefunden',
    emptyTitle: 'Keine Firmen gefunden',
    emptyDescription:
      'Mit den aktuellen Filtern wurden keine Münchner Umzugsfirmen gefunden. Versuche, die Filter anzupassen.',
    emptyReset: 'Filter zurücksetzen',
    loadingTitle: 'Lade Münchner Umzugsfirmen...',
    errorTitle: 'Fehler beim Laden',
    errorDescription:
      'Die Liste der Münchner Umzugsfirmen konnte nicht geladen werden. Bitte versuche es erneut.',
    errorRetry: 'Erneut versuchen',
    paginationPrev: 'Zurück',
    paginationNext: 'Weiter',
    paginationPage: 'Seite {{page}} von {{total}}',
  },
  koelnLanding: {
    metaTitle: 'Umzug Köln | RegionalUmzug24 - Umzugsfirmen vergleichen',
    metaDescription:
      'Finde die besten Umzugsfirmen in Köln. Kostenlos Angebote von verifizierten Kölner Umzugsunternehmen vergleichen. Rheinland-Erfahrung, Halteverbotszonen.',
    metaKeywords: 'Umzug Köln, Umzugsfirmen Köln, Umzugskosten Köln, Umzugsunternehmen Köln',
    heroTitleStart: 'Ihr Umzug in',
    heroTitleHighlight: 'Köln.',
    heroSubtitle:
      'Vergleichen Sie kostenlos geprüfte Kölner Umzugsfirmen mit Erfahrung rund um Dom, Südstadt und Rhein.',
    heroCtaPrimary: 'Jetzt Angebote erhalten',
    heroCtaSecondary: 'Kölner Firmen ansehen',
    heroStatFirms: '150+ Kölner Firmen',
    heroStatMoves: '400+ vermittelte Umzüge',
    heroStatRating: '4,7/5 Bewertung',
    benefitsTitle: 'Deine Vorteile mit RegionalUmzug24 in Köln',
    benefitsSubtitle: 'Warum sich Kölner Kund:innen für unsere Vermittlungsplattform entscheiden',
    benefitFreeTitle: '100 % kostenlos',
    benefitFreeDesc:
      'Die Anfrage und der Vergleich sind für dich komplett kostenfrei und unverbindlich.',
    benefitLocalTitle: 'Lokale Kölner Firmen',
    benefitLocalDesc:
      'Wir vermitteln ausschließlich geprüfte Umzugsfirmen mit Service in Köln und Umland (PLZ 50-51).',
    benefitReviewsTitle: 'Echte Bewertungen',
    benefitReviewsDesc:
      'Lies verifizierte Kundenbewertungen und entscheide dich auf Basis echter Erfahrungen.',
    statsTitle: 'Umzug in Köln in Zahlen',
    statsSubtitle: 'Kölner Kund:innen vertrauen auf RegionalUmzug24',
    statFirms: '150+',
    statFirmsLabel: 'Kölner Umzugsfirmen',
    statMoves: '400+',
    statMovesLabel: 'Vermittelte Umzüge',
    statSavings: '36 %',
    statSavingsLabel: 'Durchschn. Ersparnis',
    statRating: '4,7/5',
    statRatingLabel: 'Kundenbewertung',
    processTitle: 'So läuft Ihr Umzug in Köln ab',
    processSubtitle: 'In drei einfachen Schritten zu Ihrem Wunschumzug in der Domstadt',
    step1Title: 'Anfrage stellen',
    step1Desc: 'Beschreiben Sie Ihren Kölner Umzug in wenigen Schritten online.',
    step2Title: 'Kölner Firmen erhalten',
    step2Desc:
      'Passende Kölner Umzugsfirmen senden Ihnen ihre Angebote – inklusive Erfahrung für Halteverbotszonen.',
    step3Title: 'Firma wählen',
    step3Desc: 'Vergleichen Sie Bewertungen und wählen Sie die passende Kölner Firma.',
    trustTitle: 'Geprüfte Kölner Umzugsfirmen',
    trustSubtitle: 'Sicherheit und Qualität – speziell für die Rheinmetropole',
    trustVerifiedTitle: 'Verifizierte Kölner Firmen',
    trustVerifiedDesc:
      'Jede Umzugsfirma wird auf Gewerbeanmeldung, Versicherung und Erfahrung im Rheinland geprüft.',
    trustGdprTitle: 'DSGVO-konform',
    trustGdprDesc: 'Ihre Daten werden verschlüsselt übertragen und nicht an Dritte weitergegeben.',
    trustFreeTitle: '100 % kostenlos',
    trustFreeDesc:
      'Die Nutzung von RegionalUmzug24 ist für Sie komplett kostenfrei – ohne versteckte Gebühren.',
    faqTitle: 'Häufige Fragen zum Umzug in Köln',
    faqSubtitle: 'Antworten auf die wichtigsten Fragen rund um Kölner Umzüge',
    faq1Question: 'Was kostet ein Umzug in Köln?',
    faq1Answer:
      'Die Kosten für einen Kölner Umzug hängen von Wohnfläche, Etage und der Notwendigkeit einer Halteverbotszone ab. Ein 3-Zimmer-Umzug innerhalb Kölns kostet zwischen 750 und 1.500 Euro.',
    faq2Question: 'Wie finde ich eine seriöse Umzugsfirma in Köln?',
    faq2Answer:
      'Achten Sie auf verifizierte Bewertungen, Erfahrung mit Kölner Altbauten und Kenntnis der Halteverbotszonen rund um den Dom.',
    faq3Question: 'Werden Halteverbotszonen in Köln eingerichtet?',
    faq3Answer:
      'Ja, vor allem in der Südstadt und in der Innenstadt sind Halteverbotszonen häufig nötig. Unsere Partner übernehmen die Beantragung.',
    faq4Question: 'Wie lange dauert ein Umzug in Köln?',
    faq4Answer:
      'Ein 3-Zimmer-Umzug innerhalb Kölns dauert in der Regel vier bis acht Stunden, je nach Stockwerk und Verkehrslage.',
    faq5Question: 'Können Umzüge über den Rhein hinweg organisiert werden?',
    faq5Answer:
      'Ja, geprüfte Kölner Umzugsfirmen kennen die Rheinbrücken und organisieren Umzüge zwischen links- und rechtsrheinischem Ufer.',
    ctaTitle: 'Bereit für deinen Umzug in Köln?',
    ctaSubtitle:
      'Erstelle jetzt kostenlos deine Anfrage und erhalte Angebote von geprüften Kölner Umzugsfirmen.',
    ctaPrimary: 'Jetzt Anfrage erstellen',
    ctaSecondary: 'Kölner Firmen ansehen',
  },
  koelnDirectory: {
    metaTitle: 'Umzugsfirmen Köln | RegionalUmzug24 - Kölner Firmen vergleichen',
    metaDescription:
      'Liste geprüfter Umzugsfirmen in Köln. Vergleiche Bewertungen, Spezialgebiete und Preise von Kölner Umzugsunternehmen im PLZ-Bereich 50-51.',
    metaKeywords:
      'Umzugsfirmen Köln, Umzugsunternehmen Köln, Kölner Umzugsfirma, Umzug Köln Firmen',
    pageTitle: 'Umzugsfirmen in Köln',
    pageSubtitle:
      'Entdecke geprüfte Kölner Umzugsfirmen mit echten Bewertungen. PLZ-Bereich 50-51 – vom Rheinauhafen bis nach Mülheim.',
    filterTitle: 'Filter',
    filterPremium: 'Nur Premium-Firmen',
    filterVerified: 'Nur verifizierte Firmen',
    filterPostalTitle: 'PLZ-Bereich',
    filterPostalAll: 'Alle PLZ-Bereiche',
    filterPostal50: 'PLZ 50 (Innenstadt)',
    filterPostal51: 'PLZ 51 (rechtsrh.)',
    sortTitle: 'Sortierung',
    sortRating: 'Beste Bewertung',
    sortOrders: 'Meiste Aufträge',
    sortNewest: 'Neueste',
    resultCount: '{{count}} Firmen gefunden',
    emptyTitle: 'Keine Firmen gefunden',
    emptyDescription:
      'Mit den aktuellen Filtern wurden keine Kölner Umzugsfirmen gefunden. Versuche, die Filter anzupassen.',
    emptyReset: 'Filter zurücksetzen',
    loadingTitle: 'Lade Kölner Umzugsfirmen...',
    errorTitle: 'Fehler beim Laden',
    errorDescription:
      'Die Liste der Kölner Umzugsfirmen konnte nicht geladen werden. Bitte versuche es erneut.',
    errorRetry: 'Erneut versuchen',
    paginationPrev: 'Zurück',
    paginationNext: 'Weiter',
    paginationPage: 'Seite {{page}} von {{total}}',
  },
  frankfurtLanding: {
    metaTitle: 'Umzug Frankfurt | RegionalUmzug24 - Umzugsfirmen vergleichen',
    metaDescription:
      'Finde die besten Umzugsfirmen in Frankfurt am Main. Kostenlos Angebote von verifizierten Frankfurter Umzugsunternehmen vergleichen. Banken- und Bürologistik.',
    metaKeywords:
      'Umzug Frankfurt, Umzugsfirmen Frankfurt, Umzugskosten Frankfurt, Umzugsunternehmen Frankfurt',
    heroTitleStart: 'Ihr Umzug in',
    heroTitleHighlight: 'Frankfurt.',
    heroSubtitle:
      'Vergleichen Sie kostenlos geprüfte Frankfurter Umzugsfirmen – vom Bankenviertel bis nach Sachsenhausen.',
    heroCtaPrimary: 'Jetzt Angebote erhalten',
    heroCtaSecondary: 'Frankfurter Firmen ansehen',
    heroStatFirms: '160+ Frankfurter Firmen',
    heroStatMoves: '410+ vermittelte Umzüge',
    heroStatRating: '4,7/5 Bewertung',
    benefitsTitle: 'Deine Vorteile mit RegionalUmzug24 in Frankfurt am Main',
    benefitsSubtitle: 'Warum sich Frankfurter Kund:innen für unsere Plattform entscheiden',
    benefitFreeTitle: '100 % kostenlos',
    benefitFreeDesc:
      'Die Anfrage und der Vergleich sind für dich komplett kostenfrei und unverbindlich.',
    benefitLocalTitle: 'Lokale Frankfurter Firmen',
    benefitLocalDesc:
      'Wir vermitteln ausschließlich geprüfte Umzugsfirmen mit Service in Frankfurt und Umland (PLZ 60-65).',
    benefitReviewsTitle: 'Echte Bewertungen',
    benefitReviewsDesc:
      'Lies verifizierte Kundenbewertungen und entscheide dich auf Basis echter Erfahrungen.',
    statsTitle: 'Umzug in Frankfurt in Zahlen',
    statsSubtitle: 'Frankfurter Kund:innen vertrauen auf RegionalUmzug24',
    statFirms: '160+',
    statFirmsLabel: 'Frankfurter Umzugsfirmen',
    statMoves: '410+',
    statMovesLabel: 'Vermittelte Umzüge',
    statSavings: '37 %',
    statSavingsLabel: 'Durchschn. Ersparnis',
    statRating: '4,7/5',
    statRatingLabel: 'Kundenbewertung',
    processTitle: 'So läuft Ihr Umzug in Frankfurt ab',
    processSubtitle: 'In drei einfachen Schritten zu Ihrem Wunschumzug in der Mainmetropole',
    step1Title: 'Anfrage stellen',
    step1Desc: 'Beschreiben Sie Ihren Frankfurter Umzug in wenigen Schritten online.',
    step2Title: 'Frankfurter Firmen erhalten',
    step2Desc:
      'Passende Frankfurter Umzugsfirmen senden Ihnen ihre Angebote – auch für Büros im Bankenviertel.',
    step3Title: 'Firma wählen',
    step3Desc: 'Vergleichen Sie Bewertungen und wählen Sie die passende Frankfurter Firma.',
    trustTitle: 'Geprüfte Frankfurter Umzugsfirmen',
    trustSubtitle: 'Sicherheit und Qualität – speziell für die Mainmetropole',
    trustVerifiedTitle: 'Verifizierte Frankfurter Firmen',
    trustVerifiedDesc:
      'Jede Umzugsfirma wird auf Gewerbeanmeldung, Versicherung und Hochhauserfahrung geprüft.',
    trustGdprTitle: 'DSGVO-konform',
    trustGdprDesc: 'Ihre Daten werden verschlüsselt übertragen und nicht an Dritte weitergegeben.',
    trustFreeTitle: '100 % kostenlos',
    trustFreeDesc:
      'Die Nutzung von RegionalUmzug24 ist für Sie komplett kostenfrei – ohne versteckte Gebühren.',
    faqTitle: 'Häufige Fragen zum Umzug in Frankfurt',
    faqSubtitle: 'Antworten auf die wichtigsten Fragen rund um Frankfurter Umzüge',
    faq1Question: 'Was kostet ein Umzug in Frankfurt?',
    faq1Answer:
      'Die Kosten für einen Frankfurter Umzug hängen von Wohnfläche, Etage und Aufzugssituation ab. Ein 3-Zimmer-Umzug innerhalb Frankfurts kostet zwischen 850 und 1.700 Euro.',
    faq2Question: 'Wie finde ich eine seriöse Umzugsfirma in Frankfurt?',
    faq2Answer:
      'Achten Sie auf verifizierte Bewertungen, Erfahrung mit Frankfurter Hochhäusern und nachgewiesene Bürologistik.',
    faq3Question: 'Werden Halteverbotszonen in Frankfurt eingerichtet?',
    faq3Answer:
      'Ja, vor allem in Westend und im Bankenviertel sind Halteverbotszonen häufig notwendig. Unsere Partner übernehmen die Beantragung.',
    faq4Question: 'Wie lange dauert ein Umzug in Frankfurt?',
    faq4Answer:
      'Ein typischer Frankfurter 3-Zimmer-Umzug dauert fünf bis acht Stunden, abhängig von Stockwerk und Verkehrslage.',
    faq5Question: 'Können internationale Umzüge ab Frankfurt organisiert werden?',
    faq5Answer:
      'Ja, geprüfte Frankfurter Umzugsfirmen bieten auch internationale Umzüge inklusive Zollabwicklung an.',
    ctaTitle: 'Bereit für deinen Umzug in Frankfurt?',
    ctaSubtitle:
      'Erstelle jetzt kostenlos deine Anfrage und erhalte Angebote von geprüften Frankfurter Umzugsfirmen.',
    ctaPrimary: 'Jetzt Anfrage erstellen',
    ctaSecondary: 'Frankfurter Firmen ansehen',
  },
  frankfurtDirectory: {
    metaTitle: 'Umzugsfirmen Frankfurt | RegionalUmzug24 - Frankfurter Firmen vergleichen',
    metaDescription:
      'Liste geprüfter Umzugsfirmen in Frankfurt am Main. Vergleiche Bewertungen, Spezialgebiete und Preise von Frankfurter Umzugsunternehmen im PLZ-Bereich 60-65.',
    metaKeywords:
      'Umzugsfirmen Frankfurt, Umzugsunternehmen Frankfurt, Frankfurter Umzugsfirma, Umzug Frankfurt Firmen',
    pageTitle: 'Umzugsfirmen in Frankfurt am Main',
    pageSubtitle:
      'Entdecke geprüfte Frankfurter Umzugsfirmen mit echten Bewertungen. PLZ-Bereich 60-65 – vom Westend bis Höchst.',
    filterTitle: 'Filter',
    filterPremium: 'Nur Premium-Firmen',
    filterVerified: 'Nur verifizierte Firmen',
    filterPostalTitle: 'PLZ-Bereich',
    filterPostalAll: 'Alle PLZ-Bereiche',
    filterPostal60: 'PLZ 60 (Stadtmitte)',
    filterPostal65: 'PLZ 65 (Westen)',
    sortTitle: 'Sortierung',
    sortRating: 'Beste Bewertung',
    sortOrders: 'Meiste Aufträge',
    sortNewest: 'Neueste',
    resultCount: '{{count}} Firmen gefunden',
    emptyTitle: 'Keine Firmen gefunden',
    emptyDescription:
      'Mit den aktuellen Filtern wurden keine Frankfurter Umzugsfirmen gefunden. Versuche, die Filter anzupassen.',
    emptyReset: 'Filter zurücksetzen',
    loadingTitle: 'Lade Frankfurter Umzugsfirmen...',
    errorTitle: 'Fehler beim Laden',
    errorDescription:
      'Die Liste der Frankfurter Umzugsfirmen konnte nicht geladen werden. Bitte versuche es erneut.',
    errorRetry: 'Erneut versuchen',
    paginationPrev: 'Zurück',
    paginationNext: 'Weiter',
    paginationPage: 'Seite {{page}} von {{total}}',
  },
  stuttgartLanding: {
    metaTitle: 'Umzug Stuttgart | RegionalUmzug24 - Umzugsfirmen vergleichen',
    metaDescription:
      'Finde die besten Umzugsfirmen in Stuttgart. Kostenlos Angebote von verifizierten Stuttgarter Umzugsunternehmen vergleichen. Steillagen, Talkessel, Filder.',
    metaKeywords:
      'Umzug Stuttgart, Umzugsfirmen Stuttgart, Umzugskosten Stuttgart, Umzugsunternehmen Stuttgart',
    heroTitleStart: 'Ihr Umzug in',
    heroTitleHighlight: 'Stuttgart.',
    heroSubtitle:
      'Vergleichen Sie kostenlos geprüfte Stuttgarter Umzugsfirmen mit Erfahrung im Talkessel und auf den Fildern.',
    heroCtaPrimary: 'Jetzt Angebote erhalten',
    heroCtaSecondary: 'Stuttgarter Firmen ansehen',
    heroStatFirms: '140+ Stuttgarter Firmen',
    heroStatMoves: '380+ vermittelte Umzüge',
    heroStatRating: '4,7/5 Bewertung',
    benefitsTitle: 'Deine Vorteile mit RegionalUmzug24 in Stuttgart',
    benefitsSubtitle:
      'Warum sich Stuttgarter Kund:innen für unsere Vermittlungsplattform entscheiden',
    benefitFreeTitle: '100 % kostenlos',
    benefitFreeDesc:
      'Die Anfrage und der Vergleich sind für dich komplett kostenfrei und unverbindlich.',
    benefitLocalTitle: 'Lokale Stuttgarter Firmen',
    benefitLocalDesc:
      'Wir vermitteln ausschließlich geprüfte Umzugsfirmen mit Service in Stuttgart und Umland (PLZ 70).',
    benefitReviewsTitle: 'Echte Bewertungen',
    benefitReviewsDesc:
      'Lies verifizierte Kundenbewertungen und entscheide dich auf Basis echter Erfahrungen.',
    statsTitle: 'Umzug in Stuttgart in Zahlen',
    statsSubtitle: 'Stuttgarter Kund:innen vertrauen auf RegionalUmzug24',
    statFirms: '140+',
    statFirmsLabel: 'Stuttgarter Umzugsfirmen',
    statMoves: '380+',
    statMovesLabel: 'Vermittelte Umzüge',
    statSavings: '34 %',
    statSavingsLabel: 'Durchschn. Ersparnis',
    statRating: '4,7/5',
    statRatingLabel: 'Kundenbewertung',
    processTitle: 'So läuft Ihr Umzug in Stuttgart ab',
    processSubtitle: 'In drei einfachen Schritten zu Ihrem Wunschumzug in der Schwabenmetropole',
    step1Title: 'Anfrage stellen',
    step1Desc:
      'Beschreiben Sie Ihren Stuttgarter Umzug in wenigen Schritten – auch Steillagen und Parkplatzsituation.',
    step2Title: 'Stuttgarter Firmen erhalten',
    step2Desc:
      'Passende Stuttgarter Umzugsfirmen senden Ihnen ihre Angebote – inklusive Erfahrung für den Talkessel.',
    step3Title: 'Firma wählen',
    step3Desc:
      'Vergleichen Sie Bewertungen und wählen Sie die passende Firma für Ihren Stuttgarter Umzug.',
    trustTitle: 'Geprüfte Stuttgarter Umzugsfirmen',
    trustSubtitle: 'Sicherheit und Qualität – speziell für die Schwabenmetropole',
    trustVerifiedTitle: 'Verifizierte Stuttgarter Firmen',
    trustVerifiedDesc:
      'Jede Umzugsfirma wird auf Gewerbeanmeldung, Versicherung und Erfahrung mit Steillagen geprüft.',
    trustGdprTitle: 'DSGVO-konform',
    trustGdprDesc: 'Ihre Daten werden verschlüsselt übertragen und nicht an Dritte weitergegeben.',
    trustFreeTitle: '100 % kostenlos',
    trustFreeDesc:
      'Die Nutzung von RegionalUmzug24 ist für Sie komplett kostenfrei – ohne versteckte Gebühren.',
    faqTitle: 'Häufige Fragen zum Umzug in Stuttgart',
    faqSubtitle: 'Antworten auf die wichtigsten Fragen rund um Stuttgarter Umzüge',
    faq1Question: 'Was kostet ein Umzug in Stuttgart?',
    faq1Answer:
      'Die Kosten für einen Stuttgarter Umzug hängen von Wohnfläche, Steillage und Parkplatzsituation ab. Ein 3-Zimmer-Umzug kostet meist zwischen 800 und 1.600 Euro.',
    faq2Question: 'Wie finde ich eine seriöse Umzugsfirma in Stuttgart?',
    faq2Answer:
      'Achten Sie auf verifizierte Bewertungen, Erfahrung mit Steillagen in Heslach oder Degerloch und Kenntnis der Halteverbotszonen.',
    faq3Question: 'Werden Halteverbotszonen in Stuttgart eingerichtet?',
    faq3Answer:
      'Ja, im Talkessel sind Halteverbotszonen häufig unverzichtbar. Unsere Partner kümmern sich auf Wunsch um die Beantragung.',
    faq4Question: 'Wie lange dauert ein Umzug in Stuttgart?',
    faq4Answer:
      'Ein typischer Stuttgarter 3-Zimmer-Umzug dauert zwischen fünf und acht Stunden, je nach Steillage und Verkehr.',
    faq5Question: 'Können Fernumzüge ins Schwabenland organisiert werden?',
    faq5Answer:
      'Ja, geprüfte Stuttgarter Umzugsfirmen bieten auch Fernumzüge in alle Richtungen des Schwabenlands an.',
    ctaTitle: 'Bereit für deinen Umzug in Stuttgart?',
    ctaSubtitle:
      'Erstelle jetzt kostenlos deine Anfrage und erhalte Angebote von geprüften Stuttgarter Umzugsfirmen.',
    ctaPrimary: 'Jetzt Anfrage erstellen',
    ctaSecondary: 'Stuttgarter Firmen ansehen',
  },
  stuttgartDirectory: {
    metaTitle: 'Umzugsfirmen Stuttgart | RegionalUmzug24 - Stuttgarter Firmen vergleichen',
    metaDescription:
      'Liste geprüfter Umzugsfirmen in Stuttgart. Vergleiche Bewertungen, Spezialgebiete und Preise von Stuttgarter Umzugsunternehmen im PLZ-Bereich 70.',
    metaKeywords:
      'Umzugsfirmen Stuttgart, Umzugsunternehmen Stuttgart, Stuttgarter Umzugsfirma, Umzug Stuttgart Firmen',
    pageTitle: 'Umzugsfirmen in Stuttgart',
    pageSubtitle:
      'Entdecke geprüfte Stuttgarter Umzugsfirmen mit echten Bewertungen. PLZ-Bereich 70 – vom Talkessel bis auf die Filder.',
    filterTitle: 'Filter',
    filterPremium: 'Nur Premium-Firmen',
    filterVerified: 'Nur verifizierte Firmen',
    filterPostalTitle: 'PLZ-Bereich',
    filterPostalAll: 'Alle PLZ-Bereiche',
    filterPostal70: 'PLZ 70 (Stuttgart)',
    sortTitle: 'Sortierung',
    sortRating: 'Beste Bewertung',
    sortOrders: 'Meiste Aufträge',
    sortNewest: 'Neueste',
    resultCount: '{{count}} Firmen gefunden',
    emptyTitle: 'Keine Firmen gefunden',
    emptyDescription:
      'Mit den aktuellen Filtern wurden keine Stuttgarter Umzugsfirmen gefunden. Versuche, die Filter anzupassen.',
    emptyReset: 'Filter zurücksetzen',
    loadingTitle: 'Lade Stuttgarter Umzugsfirmen...',
    errorTitle: 'Fehler beim Laden',
    errorDescription:
      'Die Liste der Stuttgarter Umzugsfirmen konnte nicht geladen werden. Bitte versuche es erneut.',
    errorRetry: 'Erneut versuchen',
    paginationPrev: 'Zurück',
    paginationNext: 'Weiter',
    paginationPage: 'Seite {{page}} von {{total}}',
  },
  volumeCalculator: {
    title: 'Volumen-Rechner',
    apartmentType: 'Wohnungstyp',
    rooms: {
      '1': '1-Zi',
      '2': '2-Zi',
      '3': '3-Zi',
      '4': '4-Zi',
      '5plus': '5+-Zi',
    },
    livingArea: 'Wohnfläche',
    additionalFloors: 'Zusätzliche Etagen (Keller, Dachboden)',
    estimated: 'Geschätztes Umzugsvolumen:',
    applyToForm: 'In Anfrage übernehmen',
    toggleAuto: 'Volumen automatisch berechnen',
    toggleManual: 'Manuell eingeben',
    // OPT373 — hardcoded German strings in VolumeCalculator.tsx
    livingAreaUnit: 'm²',
    floorSurchargeHint: '+5 m³ pro Etage',
    volumeUnit: 'm³',
  },
  payment: {
    success: {
      metaTitle: 'Zahlung erfolgreich',
      metaDescription: 'Der Bezahlvorgang für regionalumzug24 wurde erfolgreich abgeschlossen.',
      title: 'Zahlung erfolgreich',
      description:
        'Der Bezahlvorgang wurde abgeschlossen. Die Anfrage wird im Firmen-Dashboard aktualisiert.',
      paymentIdLabel: 'Zahlungs-ID:',
      dashboardButton: 'Zum Dashboard',
      homeButton: 'Startseite',
    },
    cancel: {
      metaTitle: 'Zahlung abgebrochen',
      metaDescription:
        'Der Checkout wurde nicht abgeschlossen und kann im Firmen-Dashboard erneut gestartet werden.',
      title: 'Zahlung abgebrochen',
      description:
        'Der Checkout wurde nicht abgeschlossen. Sie können den Vorgang im Firmen-Dashboard erneut starten.',
      paymentIdLabel: 'Zahlungs-ID:',
      dashboardButton: 'Zurück zum Dashboard',
      homeButton: 'Startseite',
    },
  },
  requestNewForm: {
    moveTypeHeading: 'Umzugsart',
    moveTypeLabel: 'Art des Umzugs *',
    moveTypePrivate: 'Privatumzug',
    moveTypeBusiness: 'Firmenumzug',
    moveTypeLongDistance: 'Fernumzug',
    moveTypeInternational: 'Internationaler Umzug',
    moveTypeSpecial: 'Spezialtransport',
    tierLabel: 'Anfrage-Typ *',
    tierStandard: 'Standard (kostenlos)',
    tierPremium: 'Premium (kostenpflichtig)',
    tierPremiumPlus: 'Premium+ (kostenpflichtig)',
    tierPaidNotice: '⚠️ Kostenpflichtiger Service',
    addressesHeading: 'Adressen',
    startAddressLabel: 'Startadresse *',
    startPostalCodeLabel: 'PLZ (Start) *',
    endAddressLabel: 'Zieladresse *',
    endPostalCodeLabel: 'PLZ (Ziel) *',
    endPostalCodePlaceholder: 'z.B. 80331',
    detailsHeading: 'Details',
    moveDateLabel: 'Umzugsdatum *',
    moveDatePlaceholder: 'Datum wählen',
    volumeLabel: 'Umfang (m³)',
    volumePlaceholder: 'z.B. 30',
    volumeHint: 'Als Richtwert: 1-Zimmer ≈ 20m³, 2-Zimmer ≈ 35m³, 3-Zimmer ≈ 50m³',
    specialHeading: 'Sonderwünsche',
    descriptionLabel: 'Zusätzliche Informationen',
    infoFreeTitle: 'Kostenlos & unverbindlich',
    infoFreeDesc: 'Ihre Anfrage ist komplett kostenfrei und verpflichtet Sie zu nichts',
    infoGdprTitle: 'DSGVO-konform',
    infoGdprDesc: 'Ihre Daten werden sicher und verschlüsselt übertragen',
    infoFastTitle: 'Schnelle Antworten',
    infoFastDesc: 'Erhalten Sie Angebote innerhalb von 24 Stunden',
    cancelButton: 'Abbrechen',
    accountCreatedTitle: 'Konto wurde erstellt',
    accountCreatedDesc:
      'Für Sie wurde automatisch ein Konto angelegt. Bitte notieren Sie sich Ihr Passwort – es wird aus Sicherheitsgründen nur einmal angezeigt.',
    passwordLabel: 'Ihr Passwort',
    emailLabel: 'E-Mail:',
    loginButton: 'Verstanden – zum Login',
  },
  requestDetail: {
    caseProfileHeading: 'Fallprofil',
    caseProfileCoverage: 'Kostenübernahme:',
    caseProfileAuthority: 'Behörde / Träger:',
    caseProfileReference: 'Aktenzeichen:',
    caseProfileContact: 'Kontakt:',
    caseProfilePhone: 'Telefon:',
    caseProfileNote: 'Hinweis:',
    caseProfileEmpty: 'Für diese Anfrage wurden noch keine Zusatzangaben hinterlegt.',
    checklistHeading: 'Nachweis-Checkliste',
    checklistEmpty: 'Derzeit fehlen keine erwarteten Nachweise.',
    documentCustomerIdentity: 'Ausweis / Identitätsnachweis',
    documentCoverageApproval: 'Kostenübernahme / Bewilligung',
    documentAuthorityReference: 'Behördenunterlage / Aktenzeichen',
    documentCareLevelProof: 'Pflegegrad- / Pflegekassennachweis',
    loadErrorTitle: 'Fehler',
    loadErrorDescription: 'Angebote konnten nicht geladen werden.',
    refreshSuccessTitle: 'Aktualisiert',
    refreshSuccessDescription: 'Angebote wurden aktualisiert.',
    refreshErrorTitle: 'Fehler',
    refreshErrorDescription: 'Aktualisierung fehlgeschlagen.',
  },
  firmaRequestDetail: {
    caseProfileHeading: 'Fallprofil',
    caseProfileCoverage: 'Kostenübernahme:',
    caseProfileAuthority: 'Behörde / Träger:',
    caseProfileReference: 'Aktenzeichen:',
    caseProfileNote: 'Hinweis:',
    caseProfileEmpty: 'Keine zusätzlichen Fallangaben vorhanden.',
    customerDocumentsHeading: 'Kundendokumente',
    customerDocumentsEmpty: 'Noch keine Kundendokumente hochgeladen.',
    documentCustomerIdentity: 'Ausweis / Identitätsnachweis',
    documentCoverageApproval: 'Kostenübernahme / Bewilligung',
    documentAuthorityReference: 'Behördenunterlage / Aktenzeichen',
    documentCareLevelProof: 'Pflegegrad- / Pflegekassennachweis',
  },
  adminLegalContentDialog: {
    savedTitle: 'Gespeichert',
    savedDescription: 'Die rechtlichen Inhalte wurden aktualisiert.',
    errorTitle: 'Fehler',
    errorDescription: 'Die Inhalte konnten nicht gespeichert werden.',
    dialogTitle: 'Rechtliche Inhalte bearbeiten',
    dialogDescription: 'Bearbeiten Sie Impressum, Datenschutzerklärung und AGB',
    contentLabelSuffix: ' Inhalt',
    contentPlaceholderPrefix: 'HTML-Inhalt für ',
    contentPlaceholderSuffix: '...',
    contentHint: 'Sie können HTML verwenden. Grundstruktur wird automatisch erstellt.',
    cancelButton: 'Abbrechen',
    saveButton: 'Speichern',
    savingButton: 'Speichern...',
    tab: {
      impressum: 'Impressum',
      datenschutz: 'Datenschutz',
      agb: 'AGB',
    },
  },
  adminCompanyManagementDialog: {
    editTitle: 'Firma bearbeiten',
    newTitle: 'Neue Firma',
    editDescription: 'Firmendaten aktualisieren',
    newDescription: 'Neue Firma anlegen',
    userEmailLabel: 'Benutzer-E-Mail',
    userPasswordLabel: 'Benutzer-Passwort',
    nameLabel: 'Firmenname',
    emailLabel: 'Firmen-E-Mail',
    phoneLabel: 'Telefon',
    descriptionLabel: 'Beschreibung',
    statusLabel: 'Status',
    statusPending: 'Ausstehend',
    statusVerified: 'Verifiziert',
    statusRejected: 'Abgelehnt',
    cancelButton: 'Abbrechen',
    saveButton: 'Speichern',
    savingButton: 'Speichern...',
    updateSuccessTitle: 'Firma aktualisiert',
    updateSuccessDescription: 'Änderungen wurden erfolgreich gespeichert.',
    createSuccessTitle: 'Firma erstellt',
    createSuccessDescription: 'Die neue Firma wurde erfolgreich angelegt.',
    userCreateErrorMessage: 'Benutzer konnte nicht angelegt werden.',
    userEmailAlreadyRegistered: 'E-Mail ist bereits registriert',
    saveErrorTitle: 'Fehler',
    saveErrorDescription: 'Firma konnte nicht gespeichert werden.',
  },
  compare: {
    metaTitle: 'Umzugsfirmen vergleichen | RegionalUmzug24',
    metaDescription:
      'Vergleiche bis zu 3 geprüfte Umzugsfirmen Seite an Seite: Preis, Bewertung, Services und Verfügbarkeit.',
    title: 'Umzugsfirmen vergleichen',
    subtitle: 'Wähle bis zu {{max}} Firmen aus und vergleiche sie Seite an Seite.',
    selectHeading: '{{count}} von {{max}} Firmen ausgewählt',
    tableHeading: 'Vergleichsdetails',
    criteria: 'Kriterium',
    rating: 'Bewertung',
    price: 'Preis',
    tier: 'Tarif',
    services: 'Leistungen',
    serviceArea: 'Einsatzgebiet',
    gallery: 'Galerie',
    noGallery: 'Keine Bilder verfügbar',
    reviews: 'Bewertungen',
    verified: 'Verifiziert',
    premium: 'Premium',
    addToCompare: 'Zum Vergleich hinzufügen',
    removeFromCompare: 'Aus Vergleich entfernen',
    maxThree: 'Maximal 3 Firmen können gleichzeitig verglichen werden.',
    sendRequestToAll: 'Anfrage an alle {{count}} senden',
    clearAll: 'Vergleich leeren',
    emptyTitle: 'Noch keine Firmen ausgewählt',
    emptyDescription: 'Wähle links bis zu 3 Umzugsfirmen aus, um sie im Detail zu vergleichen.',
    emptyCta: 'Firmen entdecken',
    ctaDescription:
      'Du hast {{count}} Firmen ausgewählt. Sende jetzt eine Anfrage an alle gleichzeitig.',
    loginRequired: 'Bitte melde dich an, um eine Anfrage zu senden.',
    bulkRequestDescription:
      'Vergleichsanfrage über mehrere Umzugsfirmen, erstellt aus dem Vergleichstool.',
    requestSentTitle: 'Anfrage gesendet',
    requestSentDescription: 'Deine Anfrage wurde an {{count}} Firmen gesendet.',
    requestSendError: 'Die Anfrage konnte nicht gesendet werden. Bitte versuche es erneut.',
    sending: 'Wird gesendet...',
    floatingBar: '{{count}} im Vergleich',
    openComparison: 'Vergleich öffnen',
    bulkDispatchAction: 'An alle {{count}} anfragen',
    bulkDispatchSending: 'Wird gesendet...',
    bulkDispatchSuccessTitle: 'Anfrage gesendet',
    bulkDispatchSuccessDescription: 'Anfrage an {{count}} Firmen gesendet.',
    bulkDispatchErrorTitle: 'Senden fehlgeschlagen',
    bulkDispatchErrorDescription: 'Die Anfrage konnte nicht gesendet werden.',
    bulkDispatchLoginRequiredTitle: 'Anmeldung erforderlich',
    bulkDispatchLoginRequiredDescription: 'Bitte melde dich an, um eine Anfrage zu senden.',
    bulkDispatchNoSlugsTitle: 'Keine buchbaren Firmen',
    bulkDispatchNoSlugsDescription: 'Mindestens eine Firma benötigt eine öffentliche Profil-URL.',
    bulkDispatchDefaultAddress: 'Wird vom Kunden nachgereicht',
    bulkDispatchSecondaryErrorTitle: 'Anfrage gesendet, Folge-Schritt fehlgeschlagen',
    bulkDispatchSecondaryErrorDescription:
      'Die Anfrage wurde gesendet, aber ein interner Folge-Schritt ist fehlgeschlagen.',
  },
  packingUpsell: {
    title: 'Verpackungs-Service dazubuchen?',
    subtitle:
      'Spart Zeit und schützt dein Hab und Gut. Wähle das passende Paket – die Firmen passen ihre Angebote entsprechend an.',
    toggleLabel: 'Verpackungs-Service',
    selected: 'Ausgewählt',
    priceLabel: '(Aufschlag)',
    empty: 'Aktuell sind keine Verpackungs-Pakete verfügbar.',
    loadError: 'Verpackungs-Pakete konnten nicht geladen werden.',
    tier: {
      basic: {
        name: 'Basic',
        description: '20 stabile Umzugskartons inkl. Packpapier.',
      },
      standard: {
        name: 'Standard',
        description: '40 Kartons, Packpapier und Luftpolsterfolie.',
      },
      premium: {
        name: 'Premium',
        description: 'Unbegrenzte Kartons plus Profi-Packteam für 4 Stunden.',
      },
    },
  },
  visitScheduler: {
    title: 'Besichtigungstermin anfragen',
    subtitle:
      'Lassen Sie die Umzugsfirmen Ihr Hab und Gut vor Ort einschätzen – kostenlos und unverbindlich (1–2 Wochen Vorlauf).',
    dateLabel: 'Wunschdatum',
    datePlaceholder: 'Datum wählen',
    timeLabel: 'Uhrzeit',
    timePlaceholder: 'Uhrzeit wählen',
    notesLabel: 'Notizen (optional)',
    notesPlaceholder: 'z. B. „3. OG ohne Aufzug"',
    submit: 'Besichtigung anfragen',
    submitting: 'Wird gesendet...',
    confirmed: 'Besichtigung bestätigt für {{date}}.',
    removeVisit: 'Termin entfernen',
    errors: {
      missingSelection: 'Bitte Datum und Uhrzeit auswählen.',
      invalidDate: 'Das ausgewählte Datum ist ungültig.',
      generic: 'Der Termin konnte nicht gespeichert werden. Bitte versuche es erneut.',
    },
  },
  // P3.5 — Insurance partner directory card
  insurancePartnerCard: {
    featuredBadge: 'Empfohlen',
    coverageHeading: 'Abgedeckte Sparten',
    coverage: {
      transport: 'Transportversicherung',
      liability: 'Haftpflichtversicherung',
      household: 'Hausratversicherung',
      full: 'Rundum-Schutz',
    },
    websiteLink: 'Zur Partner-Website',
    requestButton: 'Anfrage senden',
    requestingButton: 'Wird gesendet…',
    requestSuccessTitle: 'Anfrage gesendet',
    requestSuccessDescription:
      'Ihre Daten wurden an {{partner}} weitergeleitet. Sie erhalten in Kürze eine Rückmeldung.',
    requestErrorTitle: 'Senden fehlgeschlagen',
    requestErrorDescription:
      'Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.',
    loginRequiredTitle: 'Anmeldung erforderlich',
    loginRequiredDescription: 'Bitte melden Sie sich an, um eine Versicherungsanfrage zu senden.',
    consentLabel:
      'Ich willige ein, dass meine Kontaktdaten an den ausgewählten Versicherungspartner weitergegeben werden.',
    descriptionFallback: 'Keine Beschreibung verfügbar.',
  },
  // P3.3: branch extension v1 — Reinigung (Cleaning) landing page (DE)
  cleaningLanding: {
    metaTitle: 'Reinigung | RegionalUmzug24 - Reinigungsfirmen vergleichen',
    metaDescription:
      'Finden Sie geprüfte Reinigungsfirmen in Ihrer Region. Vergleichen Sie kostenlos Angebote für Wohnungsreinigung, Büroreinigung und Umzugsendreinigung.',
    metaKeywords:
      'Reinigung, Reinigungsfirma, Wohnungsreinigung, Büroreinigung, Umzugsendreinigung',
    heroTitleStart: 'Glänzend sauber.',
    heroTitleHighlight: 'Stressfrei.',
    heroSubtitle:
      'Vergleichen Sie kostenlos professionelle Reinigungsfirmen in Ihrer Region. Erhalten Sie bis zu 10 Angebote und finden Sie den passenden Reinigungspartner.',
    heroCtaPrimary: 'Jetzt Reinigungs-Anfrage stellen',
    heroCtaSecondary: 'Reinigungsfirmen ansehen',
    trustBadgeFree: '100% Kostenlos',
    trustBadgeVerified: 'Geprüfte Firmen',
    trustBadgeGdpr: 'DSGVO-konform',
    benefitsTitle: 'Ihre Vorteile mit RegionalUmzug24 für Reinigung',
    benefitsSubtitle: 'Warum sich unsere Kunden für unsere Reinigungs-Vermittlung entscheiden',
    benefitFreeTitle: '100% kostenlos',
    benefitFreeDesc:
      'Die Anfrage und der Vergleich sind für Sie komplett kostenfrei und unverbindlich.',
    benefitVettedTitle: 'Geprüfte Reinigungskräfte',
    benefitVettedDesc:
      'Wir vermitteln ausschließlich geprüfte Reinigungsfirmen mit Erfahrung und Versicherungsschutz.',
    benefitFastTitle: 'Schnelle Termine',
    benefitFastDesc:
      'Erhalten Sie Angebote innerhalb von 24 Stunden und buchen Sie schnell Ihren Wunschtermin.',
    statsTitle: 'Reinigungs-Service in Zahlen',
    statsSubtitle: 'Vertrauen unserer Kund:innen auf RegionalUmzug24',
    statFirms: '150+',
    statFirmsLabel: 'Geprüfte Reinigungsfirmen',
    statJobs: '300+',
    statJobsLabel: 'Vermittelte Reinigungen',
    statRating: '4,8/5',
    statRatingLabel: 'Kundenbewertung',
    servicesTitle: 'Unsere Reinigungs-Services',
    servicesSubtitle: 'Welche Art von Reinigung benötigen Sie?',
    serviceApartmentTitle: 'Wohnungsreinigung',
    serviceApartmentDesc: 'Gründliche Reinigung Ihrer Wohnung – perfekt vor oder nach einem Umzug.',
    serviceOfficeTitle: 'Büroreinigung',
    serviceOfficeDesc:
      'Regelmäßige oder einmalige professionelle Reinigung Ihres Büros oder Ihrer Praxis.',
    serviceMoveOutTitle: 'Umzugsendreinigung',
    serviceMoveOutDesc:
      'Besenreine Übergabe Ihrer alten Wohnung inkl. Abnahmegarantie mit Vermieter.',
    serviceWindowTitle: 'Fensterreinigung',
    serviceWindowDesc:
      'Streifenfreie Fenster, Rahmen und Fensterbänke – auch in schwer zugänglichen Höhen.',
    processTitle: 'So funktioniert es',
    processSubtitle: 'In nur 3 einfachen Schritten zur passenden Reinigungsfirma',
    step1Title: 'Reinigungs-Anfrage stellen',
    step1Desc: 'Beschreiben Sie Ihre Reinigung in wenigen Schritten',
    step2Title: 'Angebote erhalten',
    step2Desc: 'Passende Reinigungsfirmen senden Ihnen ihre Angebote',
    step3Title: 'Firma wählen',
    step3Desc: 'Vergleichen Sie und wählen Sie das beste Angebot',
    ctaTitle: 'Bereit für eine stressfreie Reinigung?',
    ctaSubtitle:
      'Starten Sie jetzt und erhalten Sie kostenlose Angebote von geprüften Reinigungsfirmen.',
    ctaPrimary: 'Reinigungs-Anfrage starten',
    ctaSecondary: 'Mehr erfahren',
    faqTitle: 'Häufige Fragen',
    faqSubtitle: 'Alles, was Sie über unsere Reinigungs-Vermittlung wissen müssen',
    faq1Question: 'Was kostet eine professionelle Reinigung?',
    faq1Answer:
      'Die Kosten hängen von Größe, Zustand und Art der Reinigung ab. Über uns erhalten Sie kostenlos vergleichbare Angebote und können so den besten Preis finden.',
    faq2Question: 'Sind die Reinigungsfirmen versichert?',
    faq2Answer:
      'Ja, alle vermittelten Reinigungsfirmen sind geprüft und haftpflichtversichert. So sind Sie bei eventuellen Schäden abgesichert.',
    faq3Question: 'Wie schnell bekomme ich Angebote?',
    faq3Answer:
      'In der Regel erhalten Sie innerhalb von 24 Stunden die ersten Angebote von passenden Reinigungsfirmen in Ihrer Region.',
    faq4Question: 'Kann ich die Reinigung auch kurzfristig buchen?',
    faq4Answer:
      'Ja, viele unserer Reinigungsfirmen bieten auch kurzfristige Termine an. Geben Sie einfach Ihren Wunschtermin in der Anfrage an.',
    faq5Question: 'Was ist im Preis enthalten?',
    faq5Answer:
      'Die Reinigungsfirmen erstellen individuelle Angebote. Üblich sind Reinigungsmittel, Geräte und die Arbeitszeit. Klären Sie Details direkt mit der gewählten Firma.',
  },
  // P3.3: branch extension v1 — Entrümpelung & Entsorgung landing page (DE)
  disposalLanding: {
    metaTitle: 'Entrümpelung & Entsorgung | RegionalUmzug24 - Entrümpelungsfirmen vergleichen',
    metaDescription:
      'Finden Sie geprüfte Entrümpelungs- und Entsorgungsfirmen in Ihrer Region. Vergleichen Sie kostenlos Angebote für Wohnungsauflösung, Haushaltsauflösung und Sperrmüll-Entsorgung.',
    metaKeywords: 'Entrümpelung, Entsorgung, Haushaltsauflösung, Wohnungsauflösung, Sperrmüll',
    heroTitleStart: 'Schnell entrümpelt.',
    heroTitleHighlight: 'Fachgerecht entsorgt.',
    heroSubtitle:
      'Vergleichen Sie kostenlos professionelle Entrümpelungs- und Entsorgungsfirmen in Ihrer Region. Erhalten Sie bis zu 10 Angebote und schaffen Sie Platz.',
    heroCtaPrimary: 'Jetzt Entsorgungs-Anfrage stellen',
    heroCtaSecondary: 'Entrümpelungsfirmen ansehen',
    trustBadgeFree: '100% Kostenlos',
    trustBadgeVerified: 'Geprüfte Firmen',
    trustBadgeGdpr: 'DSGVO-konform',
    benefitsTitle: 'Ihre Vorteile mit RegionalUmzug24 für Entrümpelung',
    benefitsSubtitle: 'Warum sich unsere Kunden für unsere Entrümpelungs-Vermittlung entscheiden',
    benefitFreeTitle: '100% kostenlos',
    benefitFreeDesc:
      'Die Anfrage und der Vergleich sind für Sie komplett kostenfrei und unverbindlich.',
    benefitDisposalTitle: 'Fachgerechte Entsorgung',
    benefitDisposalDesc:
      'Wir vermitteln ausschließlich geprüfte Firmen mit Entsorgungsnachweis und umweltgerechter Verwertung.',
    benefitFastTitle: 'Schnelle Termine',
    benefitFastDesc:
      'Erhalten Sie Angebote innerhalb von 24 Stunden und buchen Sie schnell Ihren Wunschtermin – auch kurzfristig.',
    statsTitle: 'Entrümpelungs-Service in Zahlen',
    statsSubtitle: 'Vertrauen unserer Kund:innen auf RegionalUmzug24',
    statFirms: '120+',
    statFirmsLabel: 'Geprüfte Entrümpelungsfirmen',
    statJobs: '250+',
    statJobsLabel: 'Vermittelte Entrümpelungen',
    statRating: '4,7/5',
    statRatingLabel: 'Kundenbewertung',
    servicesTitle: 'Unsere Entrümpelungs-Services',
    servicesSubtitle: 'Welche Art von Entrümpelung benötigen Sie?',
    serviceApartmentTitle: 'Wohnungsauflösung',
    serviceApartmentDesc:
      'Komplette oder teilweise Auflösung Ihrer Wohnung inkl. fachgerechter Entsorgung.',
    serviceHouseTitle: 'Haushaltsauflösung',
    serviceHouseDesc:
      'Auflösung ganzer Haushalte nach Todesfall, Umzug ins Pflegeheim oder Scheidung – einfühlsam und diskret.',
    serviceBasementTitle: 'Keller- & Dachbodenentrümpelung',
    serviceBasementDesc:
      'Endlich wieder Platz in Keller und Dachboden – inkl. Entsorgung von Sperrmüll und Sondermüll.',
    serviceGardenTitle: 'Gartenentrümpelung',
    serviceGardenDesc:
      'Entfernung von Gartenabfällen, alten Gartenmöbeln, Bauschutt und Co. – inkl. Abtransport.',
    processTitle: 'So funktioniert es',
    processSubtitle: 'In nur 3 einfachen Schritten zur passenden Entrümpelungsfirma',
    step1Title: 'Entrümpelungs-Anfrage stellen',
    step1Desc: 'Beschreiben Sie Ihr Anliegen in wenigen Schritten',
    step2Title: 'Angebote erhalten',
    step2Desc: 'Passende Entrümpelungsfirmen senden Ihnen ihre Angebote',
    step3Title: 'Firma wählen',
    step3Desc: 'Vergleichen Sie und wählen Sie das beste Angebot',
    ctaTitle: 'Bereit für mehr Platz?',
    ctaSubtitle:
      'Starten Sie jetzt und erhalten Sie kostenlose Angebote von geprüften Entrümpelungsfirmen.',
    ctaPrimary: 'Entrümpelungs-Anfrage starten',
    ctaSecondary: 'Mehr erfahren',
    faqTitle: 'Häufige Fragen',
    faqSubtitle: 'Alles, was Sie über unsere Entrümpelungs-Vermittlung wissen müssen',
    faq1Question: 'Was kostet eine Entrümpelung?',
    faq1Answer:
      'Die Kosten hängen von Volumen, Stockwerk, Aufwand und Entsorgungsart ab. Über uns erhalten Sie kostenlos vergleichbare Angebote.',
    faq2Question: 'Werden die Sachen fachgerecht entsorgt?',
    faq2Answer:
      'Ja, alle vermittelten Firmen sind geprüft und entsorgen fachgerecht mit Nachweis. Wertstoffe werden recycelt, Restmüll ordnungsgemäß entsorgt.',
    faq3Question: 'Wie schnell geht eine Entrümpelung?',
    faq3Answer:
      'In der Regel erhalten Sie innerhalb von 24 Stunden die ersten Angebote. Viele Firmen bieten Termine innerhalb weniger Tage an.',
    faq4Question: 'Kann ich auch nur einzelne Räume entrümpeln lassen?',
    faq4Answer:
      'Ja, Sie können die Anfrage auf einzelne Räume, Keller oder Dachboden beschränken – die Firmen erstellen ein passendes Angebot.',
    faq5Question: 'Was passiert mit wertvollen Gegenständen?',
    faq5Answer:
      'Wertvolle oder verwertbare Gegenstände können vorab aussortiert werden. Klären Sie Details direkt mit der gewählten Firma.',
  },
  // P3.3: branch switcher on the homepage (DE)
  branchSwitcher: {
    title: 'Wählen Sie Ihre Dienstleistung',
    subtitle: 'Wir vermitteln geprüfte Fachfirmen für jede Aufgabe in Ihrer Region.',
    movingTitle: 'Umzug',
    movingDesc: 'Geprüfte Umzugsfirmen für Privat- und Firmenumzüge.',
    cleaningTitle: 'Reinigung',
    cleaningDesc: 'Professionelle Reinigungsfirmen für Wohnung, Büro und Endreinigung.',
    disposalTitle: 'Entrümpelung',
    disposalDesc: 'Entrümpelungs- und Entsorgungsfirmen mit Fachnachweis.',
    cta: 'Jetzt starten',
  },
  // P3.3: admin branch workspace (DE)
  adminBranches: {
    title: 'Branchen-Verwaltung',
    subtitle: 'Aktivieren oder deaktivieren Sie Branchen und überwachen Sie deren Auslastung.',
    loadingError: 'Branchen konnten nicht geladen werden.',
    companiesLabel: 'Firmen',
    companiesSupportingLabel: 'mit dieser Branche',
    requestsAllTimeLabel: 'Anfragen gesamt',
    requestsLast30Label: 'Anfragen (30 Tage)',
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren',
    statusActive: 'Aktiv',
    statusInactive: 'Inaktiv',
    loadError: 'Branchen-Statistiken konnten nicht geladen werden.',
    toggleError: 'Status konnte nicht geändert werden.',
    refreshed: 'Branchen aktualisiert.',
  },
  // OPT309 — Company sub-bundles (services + priceTiers extended + pricingSettings + requestTypes + gallery)
  company: {
    services: {
      packing: 'Verpackung',
      assembly: 'Möbelmontage',
      disposal: 'Entrümpelung',
      storage: 'Lagerung',
      piano: 'Klaviertransport',
      international: 'International',
      renovation: 'Renovierung',
      cleaning: 'Reinigung',
      safe_transport: 'Tresortransport',
      server_transport: 'Servertransport',
      heavy_transport: 'Schwertransport',
      painting_service: 'Malerarbeiten',
    },
    priceTiers: {
      standard: 'Standard',
      premium: 'Premium',
      premiumPlus: 'Premium+',
      premiumDesc: 'Premium-Anfrage: bis zu 15 qualifizierte Angebote von geprüften Umzugsfirmen.',
      premiumPlusDesc: 'Premium+-Anfrage: bis zu 5 exklusive Angebote von Top-Umzugsfirmen.',
    },
    pricingSettings: {
      heading: 'Vergütungsmodell',
      subheading:
        'Verwalten Sie Ihr Vergütungsmodell (Lead / Provision / Festpreis) und sehen Sie die zugehörigen Statistiken ein.',
      currentTierLabel: 'Aktuelles Modell',
      noTierLabel: 'Noch kein Modell aktiviert',
      activeBadge: 'Aktiv',
      changeButton: 'Modell wechseln',
      statsHeading: 'Statistiken pro Modell',
      statsRequestsLabel: 'Anfragen',
      statsRevenueLabel: 'Umsatz',
      statsAvgLabel: 'Ø Preis',
      statsGrandTotalRequests: 'Anfragen gesamt',
      statsGrandTotalRevenue: 'Umsatz gesamt',
      statsNoData: 'Noch keine Auswertungen verfügbar',
      dialogTitle: 'Vergütungsmodell wählen',
      dialogDescription:
        'Wählen Sie das Lead-, Provisions- oder Festpreis-Modell und hinterlegen Sie die zugehörigen Werte.',
      closeButton: 'Schließen',
      loadError: 'Das Vergütungsmodell konnte nicht geladen werden.',
      loadErrorRetry: 'Erneut versuchen',
    },
    requestTypes: {
      private: 'Privatumzug',
      business: 'Firmenumzug',
      long_distance: 'Fernumzug',
      international: 'Internationaler Umzug',
      special: 'Spezialumzug',
      official_relocation: 'Behördenumzug',
      authority_relocation: 'Umzug einer öffentlichen Einrichtung',
      assisted_move: 'Umzug mit Kostenträger',
    },
    gallery: {
      title: 'Portfolio',
      empty: 'Dieses Unternehmen hat noch keine Portfolio-Bilder hinterlegt.',
      upload: 'Portfolio-Bilder hochladen',
      maxPhotos: 'Sie können bis zu 10 Portfolio-Bilder verwalten.',
      delete: 'Bild entfernen',
      edit: 'Portfolio bearbeiten',
    },
  },
};

const enResources = {
  landing: {
    heroTitleStart: 'Your Move.',
    heroTitleHighlight: 'Our Service.',
    heroSubtitle:
      'Compare professional moving companies in your region for free, receive up to 15 quotes and find the right moving partner.',
    heroCtaPrimary: 'Get Quotes Now',
    heroCtaSecondary: 'Sign In',
    trustBadgeFree: '100% Free',
    trustBadgeVerified: 'Verified Companies',
    trustBadgeGdpr: 'GDPR Compliant',
    featuresTitle: 'Why regionalumzug24?',
    featuresSubtitle: 'We connect you with the best moving companies in your region',
    featureMatchingTitle: 'Smart Matching',
    featureMatchingDesc:
      'Our system automatically finds the perfect moving companies for your requirements',
    featureVerifiedTitle: 'Verified Companies',
    featureVerifiedDesc: 'All moving companies are reviewed and verified by us',
    featureReviewsTitle: 'Review System',
    featureReviewsDesc: 'Benefit from real customer reviews and experiences',
    featureFastTitle: 'Fast Responses',
    featureFastDesc: 'Receive offers within 24 hours',
    featureTransparentTitle: 'Transparent Pricing',
    featureTransparentDesc: 'Compare prices and services easily',
    featureFreeTitle: '100% Free',
    featureFreeDesc: 'Our platform is completely free for customers',
    howItWorksTitle: 'How it works',
    howItWorksSubtitle: 'Get the best moving quote in just 3 simple steps',
    step1Title: 'Submit a Request',
    step1Desc: 'Describe your move in a few steps',
    step2Title: 'Receive Offers',
    step2Desc: 'Matching moving companies send you their offers',
    step3Title: 'Choose a Company',
    step3Desc: 'Compare and pick the best offer',
    howItWorksCta: 'Start for free now',
    ctaTitle: 'Ready for a stress-free move?',
    ctaSubtitle: 'Start now and receive free quotes from verified moving companies',
    ctaPrimary: 'Get Quotes',
    ctaSecondary: 'Sign In',
    footerBrand: 'regionalumzug24',
    footerTagline: 'Your partner for professional moving services in Germany',
    footerCustomersHeading: 'For Customers',
    footerCustomersRequest: 'Submit Request',
    footerCustomersLogin: 'Login',
    footerCompaniesHeading: 'For Companies',
    footerCompaniesRegister: 'Register',
    footerCompaniesLogin: 'Login',
    footerLegalHeading: 'Legal',
    footerImprint: 'Imprint',
    footerPrivacy: 'Privacy',
    footerTerms: 'Terms',
    footerCopyright: '© 2025 regionalumzug24. All rights reserved.',
  },
  berlinLanding: {
    metaTitle: 'Moving in Berlin | RegionalUmzug24 - Compare Moving Companies',
    metaDescription:
      'Find the best moving companies in Berlin. Compare free quotes from verified Berlin movers. Checked, Reviewed, GDPR compliant.',
    metaKeywords: 'moving Berlin, moving companies Berlin, moving costs Berlin, Berlin movers',
    benefitsTitle: 'Your benefits with RegionalUmzug24 in Berlin',
    benefitsSubtitle: 'Why thousands of Berliners choose our matching platform',
    benefitFreeTitle: '100% free of charge',
    benefitFreeDesc:
      'Creating a request and comparing quotes is completely free and non-binding for you.',
    benefitLocalTitle: 'Local Berlin companies',
    benefitLocalDesc:
      'We match only verified movers with service in Berlin and surroundings (postal codes 10-14).',
    benefitReviewsTitle: 'Real reviews',
    benefitReviewsDesc: 'Read verified customer reviews and decide based on real experiences.',
    statsTitle: 'Moving in Berlin in numbers',
    statsSubtitle: 'Berlin customers trust RegionalUmzug24',
    statFirms: '200+',
    statFirmsLabel: 'Berlin moving companies',
    statMoves: '500+',
    statMovesLabel: 'Matched moves',
    statSavings: '40%',
    statSavingsLabel: 'Avg. savings',
    statRating: '4.7/5',
    statRatingLabel: 'Customer rating',
    ctaTitle: 'Ready for your move in Berlin?',
    ctaSubtitle: 'Create your free request now and receive quotes from verified Berlin movers.',
    ctaPrimary: 'Create Request Now',
    ctaSecondary: 'View Berlin Companies',
  },
  berlinDirectory: {
    metaTitle: 'Moving Companies Berlin | RegionalUmzug24 - Compare Berlin Movers',
    metaDescription:
      'List of verified moving companies in Berlin. Compare ratings, specialties, and prices of Berlin movers in postal code areas 10-14.',
    metaKeywords:
      'moving companies Berlin, Berlin movers, Berlin moving company, Berlin moving firms',
    pageTitle: 'Moving Companies in Berlin',
    pageSubtitle:
      'Discover verified Berlin movers with real reviews. Postal code areas 10-14 - including Potsdam and Brandenburg.',
    filterTitle: 'Filters',
    filterPremium: 'Premium companies only',
    filterVerified: 'Verified companies only',
    filterPostalTitle: 'Postal code area',
    sortTitle: 'Sort by',
    sortRating: 'Best rating',
    sortOrders: 'Most orders',
    sortNewest: 'Newest',
    resultCount: '{{count}} companies found',
    emptyTitle: 'No companies found',
    emptyDescription: 'No Berlin movers match the current filters. Try adjusting the filters.',
    emptyReset: 'Reset filters',
    loadingTitle: 'Loading Berlin movers...',
    errorTitle: 'Error loading',
    errorDescription: 'The list of Berlin movers could not be loaded. Please try again.',
    errorRetry: 'Retry',
    companyVerified: 'Verified',
    companyPremium: 'Premium',
    companyReviews: 'Reviews',
    companySpecialties: 'Specialties',
    companyServiceArea: 'Service area',
    companyViewProfile: 'View profile',
    companyRequestQuote: 'Request quote',
    paginationPrev: 'Previous',
    paginationNext: 'Next',
    paginationPage: 'Page {{page}} of {{total}}',
  },
  hamburgLanding: {
    metaTitle: 'Moving Hamburg | RegionalUmzug24 - Compare Hamburg Movers',
    metaDescription:
      'Find the best moving companies in Hamburg. Compare free quotes from verified Hamburg movers with experience for harbour, Elbe and Speicherstadt.',
    metaKeywords: 'moving Hamburg, moving companies Hamburg, moving costs Hamburg, Hamburg movers',
    heroTitleStart: 'Your move to',
    heroTitleHighlight: 'Hamburg.',
    heroSubtitle:
      'Compare verified Hamburg movers for free. Experts for the harbour, the Speicherstadt and Elbe crossings.',
    heroCtaPrimary: 'Get Free Quotes',
    heroCtaSecondary: 'View Hamburg Companies',
    heroStatFirms: '180+ Hamburg companies',
    heroStatMoves: '450+ matched moves',
    heroStatRating: '4.7/5 rating',
    benefitsTitle: 'Your benefits with RegionalUmzug24 in Hamburg',
    benefitsSubtitle: 'Why Hamburgers choose our matching platform',
    benefitFreeTitle: '100% free of charge',
    benefitFreeDesc:
      'Submitting a request and comparing quotes is completely free and non-binding for you.',
    benefitLocalTitle: 'Local Hamburg companies',
    benefitLocalDesc:
      'We match only verified movers with service in Hamburg and surroundings (postal codes 20-22).',
    benefitReviewsTitle: 'Real reviews',
    benefitReviewsDesc: 'Read verified customer reviews and decide based on real experiences.',
    statsTitle: 'Moving in Hamburg in numbers',
    statsSubtitle: 'Hamburg customers trust RegionalUmzug24',
    statFirms: '180+',
    statFirmsLabel: 'Hamburg moving companies',
    statMoves: '450+',
    statMovesLabel: 'Matched moves',
    statSavings: '35%',
    statSavingsLabel: 'Avg. savings',
    statRating: '4.7/5',
    statRatingLabel: 'Customer rating',
    processTitle: 'How your Hamburg move works',
    processSubtitle: 'In three simple steps to your perfect Hamburg move',
    step1Title: 'Submit a request',
    step1Desc: 'Describe your Hamburg move in just a few steps online.',
    step2Title: 'Receive Hamburg quotes',
    step2Desc:
      'Suitable Hamburg movers send you their offers – including harbour- and Elbe-experienced teams.',
    step3Title: 'Choose a company',
    step3Desc: 'Compare ratings and choose the best company for your Hamburg move.',
    trustTitle: 'Verified Hamburg movers',
    trustSubtitle: 'Safety and quality – tailored to the Hanseatic city',
    trustVerifiedTitle: 'Verified Hamburg companies',
    trustVerifiedDesc:
      'Each mover is checked for business registration, insurance and harbour experience.',
    trustGdprTitle: 'GDPR compliant',
    trustGdprDesc: 'Your data is transmitted securely and never shared with third parties.',
    trustFreeTitle: '100% free',
    trustFreeDesc: 'Using RegionalUmzug24 is completely free for you – no hidden fees.',
    faqTitle: 'Frequently asked questions about moving in Hamburg',
    faqSubtitle: 'Answers to the most common questions about moving in Hamburg',
    faq1Question: 'How much does a move in Hamburg cost?',
    faq1Answer:
      'The cost of a Hamburg move depends on apartment size, floor and distance. A typical 3-room move within Hamburg costs between 800 and 1,600 euros.',
    faq2Question: 'How do I find a reliable mover in Hamburg?',
    faq2Answer:
      'Look for verified reviews, a Hamburg business registration and experience with Elbe crossings and no-stopping zones.',
    faq3Question: 'Are no-stopping zones arranged in Hamburg?',
    faq3Answer:
      'Yes, many Hamburg districts require a no-stopping zone. Our partner companies handle the application and setup on request.',
    faq4Question: 'How long does a move in Hamburg take?',
    faq4Answer:
      'A typical 3-room Hamburg move takes between four and eight hours depending on floor, distance and traffic.',
    faq5Question: 'Can furniture be transported across the Elbe?',
    faq5Answer:
      'Yes, verified Hamburg movers know the routes across the Elbe bridges and arrange moves to all districts north and south of the Elbe.',
    ctaTitle: 'Ready for your move in Hamburg?',
    ctaSubtitle: 'Create your free request now and receive quotes from verified Hamburg movers.',
    ctaPrimary: 'Create Request Now',
    ctaSecondary: 'View Hamburg Companies',
  },
  hamburgDirectory: {
    metaTitle: 'Moving Companies Hamburg | RegionalUmzug24 - Compare Hamburg Movers',
    metaDescription:
      'List of verified moving companies in Hamburg. Compare ratings, specialties and prices of Hamburg movers in postal code areas 20-22.',
    metaKeywords:
      'moving companies Hamburg, Hamburg movers, Hamburg moving company, moving Hamburg firms',
    pageTitle: 'Moving Companies in Hamburg',
    pageSubtitle:
      'Discover verified Hamburg movers with real reviews. Postal code areas 20-22 – from the city centre to Bergedorf.',
    filterTitle: 'Filters',
    filterPremium: 'Premium companies only',
    filterVerified: 'Verified companies only',
    filterPostalTitle: 'Postal code area',
    filterPostalAll: 'All postal code areas',
    filterPostal20: 'PLZ 20 (city centre)',
    filterPostal21: 'PLZ 21 (north)',
    filterPostal22: 'PLZ 22 (east)',
    sortTitle: 'Sort by',
    sortRating: 'Best rating',
    sortOrders: 'Most orders',
    sortNewest: 'Newest',
    resultCount: '{{count}} companies found',
    emptyTitle: 'No companies found',
    emptyDescription: 'No Hamburg movers match the current filters. Try adjusting the filters.',
    emptyReset: 'Reset filters',
    loadingTitle: 'Loading Hamburg movers...',
    errorTitle: 'Error loading',
    errorDescription: 'The list of Hamburg movers could not be loaded. Please try again.',
    errorRetry: 'Retry',
    paginationPrev: 'Previous',
    paginationNext: 'Next',
    paginationPage: 'Page {{page}} of {{total}}',
  },
  muenchenLanding: {
    metaTitle: 'Moving Munich | RegionalUmzug24 - Compare Munich Movers',
    metaDescription:
      'Find the best moving companies in Munich. Compare free quotes from verified Munich movers – discreet, safe, GDPR compliant.',
    metaKeywords: 'moving Munich, moving companies Munich, moving costs Munich, Munich movers',
    heroTitleStart: 'Your move to',
    heroTitleHighlight: 'Munich.',
    heroSubtitle:
      'Compare verified Munich movers for free – from Maxvorstadt period flats to family homes in the suburbs.',
    heroCtaPrimary: 'Get Free Quotes',
    heroCtaSecondary: 'View Munich Companies',
    heroStatFirms: '170+ Munich companies',
    heroStatMoves: '420+ matched moves',
    heroStatRating: '4.8/5 rating',
    benefitsTitle: 'Your benefits with RegionalUmzug24 in Munich',
    benefitsSubtitle: 'Why Munich customers choose our matching platform',
    benefitFreeTitle: '100% free of charge',
    benefitFreeDesc:
      'Submitting a request and comparing quotes is completely free and non-binding for you.',
    benefitLocalTitle: 'Local Munich companies',
    benefitLocalDesc:
      'We match only verified movers with service in Munich and surroundings (postal codes 80-81).',
    benefitReviewsTitle: 'Real reviews',
    benefitReviewsDesc: 'Read verified customer reviews and decide based on real experiences.',
    statsTitle: 'Moving in Munich in numbers',
    statsSubtitle: 'Munich customers trust RegionalUmzug24',
    statFirms: '170+',
    statFirmsLabel: 'Munich moving companies',
    statMoves: '420+',
    statMovesLabel: 'Matched moves',
    statSavings: '38%',
    statSavingsLabel: 'Avg. savings',
    statRating: '4.8/5',
    statRatingLabel: 'Customer rating',
    processTitle: 'How your Munich move works',
    processSubtitle: 'In three simple steps to your perfect Munich move',
    step1Title: 'Submit a request',
    step1Desc:
      'Describe your Munich move in just a few steps – including period flats and parking.',
    step2Title: 'Receive Munich quotes',
    step2Desc: 'Suitable Munich movers send you their offers – discreet service even in Schwabing.',
    step3Title: 'Choose a company',
    step3Desc: 'Compare ratings and choose the best company for your Munich move.',
    trustTitle: 'Verified Munich movers',
    trustSubtitle: 'Safety and quality – tailored to the Bavarian capital',
    trustVerifiedTitle: 'Verified Munich companies',
    trustVerifiedDesc:
      'Each mover is checked for business registration, insurance and experience with Munich period flats.',
    trustGdprTitle: 'GDPR compliant',
    trustGdprDesc: 'Your data is transmitted securely and never shared with third parties.',
    trustFreeTitle: '100% free',
    trustFreeDesc: 'Using RegionalUmzug24 is completely free for you – no hidden fees.',
    faqTitle: 'Frequently asked questions about moving in Munich',
    faqSubtitle: 'Answers to the most common questions about moving in Munich',
    faq1Question: 'How much does a move in Munich cost?',
    faq1Answer:
      'The cost of a Munich move depends on apartment size, floor and parking situation. A typical 3-room move within Munich costs between 900 and 1,800 euros.',
    faq2Question: 'How do I find a reliable mover in Munich?',
    faq2Answer:
      'Look for verified reviews, experience with Munich period flats and the ability to arrange no-stopping zones.',
    faq3Question: 'Are no-stopping zones arranged in Munich?',
    faq3Answer:
      'Yes, especially in Maxvorstadt and Schwabing, no-stopping zones are often essential. Our partners handle this on request.',
    faq4Question: 'How long does a move in Munich take?',
    faq4Answer:
      'A typical 3-room Munich move takes five to nine hours depending on floor and traffic.',
    faq5Question: 'Can long-distance moves from Munich be arranged?',
    faq5Answer:
      'Yes, verified Munich movers also offer Bavaria-wide and Germany-wide relocations from Munich.',
    ctaTitle: 'Ready for your move in Munich?',
    ctaSubtitle: 'Create your free request now and receive quotes from verified Munich movers.',
    ctaPrimary: 'Create Request Now',
    ctaSecondary: 'View Munich Companies',
  },
  muenchenDirectory: {
    metaTitle: 'Moving Companies Munich | RegionalUmzug24 - Compare Munich Movers',
    metaDescription:
      'List of verified moving companies in Munich. Compare ratings, specialties and prices of Munich movers in postal code areas 80-81.',
    metaKeywords:
      'moving companies Munich, Munich movers, Munich moving company, moving Munich firms',
    pageTitle: 'Moving Companies in Munich',
    pageSubtitle:
      'Discover verified Munich movers with real reviews. Postal code areas 80-81 – from the old town to the Munich outskirts.',
    filterTitle: 'Filters',
    filterPremium: 'Premium companies only',
    filterVerified: 'Verified companies only',
    filterPostalTitle: 'Postal code area',
    filterPostalAll: 'All postal code areas',
    filterPostal80: 'PLZ 80 (city centre)',
    filterPostal81: 'PLZ 81 (south/east)',
    sortTitle: 'Sort by',
    sortRating: 'Best rating',
    sortOrders: 'Most orders',
    sortNewest: 'Newest',
    resultCount: '{{count}} companies found',
    emptyTitle: 'No companies found',
    emptyDescription: 'No Munich movers match the current filters. Try adjusting the filters.',
    emptyReset: 'Reset filters',
    loadingTitle: 'Loading Munich movers...',
    errorTitle: 'Error loading',
    errorDescription: 'The list of Munich movers could not be loaded. Please try again.',
    errorRetry: 'Retry',
    paginationPrev: 'Previous',
    paginationNext: 'Next',
    paginationPage: 'Page {{page}} of {{total}}',
  },
  koelnLanding: {
    metaTitle: 'Moving Cologne | RegionalUmzug24 - Compare Cologne Movers',
    metaDescription:
      'Find the best moving companies in Cologne. Compare free quotes from verified Cologne movers with experience for period flats, no-stopping zones and Rhine crossings.',
    metaKeywords: 'moving Cologne, moving companies Cologne, moving costs Cologne, Cologne movers',
    heroTitleStart: 'Your move to',
    heroTitleHighlight: 'Cologne.',
    heroSubtitle:
      'Compare verified Cologne movers for free – with experience around the cathedral, Südstadt and the Rhine.',
    heroCtaPrimary: 'Get Free Quotes',
    heroCtaSecondary: 'View Cologne Companies',
    heroStatFirms: '150+ Cologne companies',
    heroStatMoves: '400+ matched moves',
    heroStatRating: '4.7/5 rating',
    benefitsTitle: 'Your benefits with RegionalUmzug24 in Cologne',
    benefitsSubtitle: 'Why Cologne customers choose our matching platform',
    benefitFreeTitle: '100% free of charge',
    benefitFreeDesc:
      'Submitting a request and comparing quotes is completely free and non-binding for you.',
    benefitLocalTitle: 'Local Cologne companies',
    benefitLocalDesc:
      'We match only verified movers with service in Cologne and surroundings (postal codes 50-51).',
    benefitReviewsTitle: 'Real reviews',
    benefitReviewsDesc: 'Read verified customer reviews and decide based on real experiences.',
    statsTitle: 'Moving in Cologne in numbers',
    statsSubtitle: 'Cologne customers trust RegionalUmzug24',
    statFirms: '150+',
    statFirmsLabel: 'Cologne moving companies',
    statMoves: '400+',
    statMovesLabel: 'Matched moves',
    statSavings: '36%',
    statSavingsLabel: 'Avg. savings',
    statRating: '4.7/5',
    statRatingLabel: 'Customer rating',
    processTitle: 'How your Cologne move works',
    processSubtitle: 'In three simple steps to your perfect Cologne move',
    step1Title: 'Submit a request',
    step1Desc: 'Describe your Cologne move in just a few steps online.',
    step2Title: 'Receive Cologne quotes',
    step2Desc:
      'Suitable Cologne movers send you their offers – including no-stopping zone handling.',
    step3Title: 'Choose a company',
    step3Desc: 'Compare ratings and choose the best Cologne company for your move.',
    trustTitle: 'Verified Cologne movers',
    trustSubtitle: 'Safety and quality – tailored to the Rhine metropolis',
    trustVerifiedTitle: 'Verified Cologne companies',
    trustVerifiedDesc:
      'Each mover is checked for business registration, insurance and Rhineland experience.',
    trustGdprTitle: 'GDPR compliant',
    trustGdprDesc: 'Your data is transmitted securely and never shared with third parties.',
    trustFreeTitle: '100% free',
    trustFreeDesc: 'Using RegionalUmzug24 is completely free for you – no hidden fees.',
    faqTitle: 'Frequently asked questions about moving in Cologne',
    faqSubtitle: 'Answers to the most common questions about moving in Cologne',
    faq1Question: 'How much does a move in Cologne cost?',
    faq1Answer:
      'The cost of a Cologne move depends on apartment size, floor and the need for a no-stopping zone. A typical 3-room move within Cologne costs between 750 and 1,500 euros.',
    faq2Question: 'How do I find a reliable mover in Cologne?',
    faq2Answer:
      'Look for verified reviews, experience with Cologne period flats and knowledge of no-stopping zones around the cathedral.',
    faq3Question: 'Are no-stopping zones arranged in Cologne?',
    faq3Answer:
      'Yes, especially in the Südstadt and inner city, no-stopping zones are often required. Our partners handle the application.',
    faq4Question: 'How long does a move in Cologne take?',
    faq4Answer:
      'A typical 3-room Cologne move takes four to eight hours depending on floor and traffic.',
    faq5Question: 'Can moves across the Rhine be arranged?',
    faq5Answer:
      'Yes, verified Cologne movers know the Rhine bridges and arrange moves between the left and right bank.',
    ctaTitle: 'Ready for your move in Cologne?',
    ctaSubtitle: 'Create your free request now and receive quotes from verified Cologne movers.',
    ctaPrimary: 'Create Request Now',
    ctaSecondary: 'View Cologne Companies',
  },
  koelnDirectory: {
    metaTitle: 'Moving Companies Cologne | RegionalUmzug24 - Compare Cologne Movers',
    metaDescription:
      'List of verified moving companies in Cologne. Compare ratings, specialties and prices of Cologne movers in postal code areas 50-51.',
    metaKeywords:
      'moving companies Cologne, Cologne movers, Cologne moving company, moving Cologne firms',
    pageTitle: 'Moving Companies in Cologne',
    pageSubtitle:
      'Discover verified Cologne movers with real reviews. Postal code areas 50-51 – from the Rheinauhafen to Mülheim.',
    filterTitle: 'Filters',
    filterPremium: 'Premium companies only',
    filterVerified: 'Verified companies only',
    filterPostalTitle: 'Postal code area',
    filterPostalAll: 'All postal code areas',
    filterPostal50: 'PLZ 50 (inner city)',
    filterPostal51: 'PLZ 51 (right Rhine)',
    sortTitle: 'Sort by',
    sortRating: 'Best rating',
    sortOrders: 'Most orders',
    sortNewest: 'Newest',
    resultCount: '{{count}} companies found',
    emptyTitle: 'No companies found',
    emptyDescription: 'No Cologne movers match the current filters. Try adjusting the filters.',
    emptyReset: 'Reset filters',
    loadingTitle: 'Loading Cologne movers...',
    errorTitle: 'Error loading',
    errorDescription: 'The list of Cologne movers could not be loaded. Please try again.',
    errorRetry: 'Retry',
    paginationPrev: 'Previous',
    paginationNext: 'Next',
    paginationPage: 'Page {{page}} of {{total}}',
  },
  frankfurtLanding: {
    metaTitle: 'Moving Frankfurt | RegionalUmzug24 - Compare Frankfurt Movers',
    metaDescription:
      'Find the best moving companies in Frankfurt am Main. Compare free quotes from verified Frankfurt movers with banking district and office logistics.',
    metaKeywords:
      'moving Frankfurt, moving companies Frankfurt, moving costs Frankfurt, Frankfurt movers',
    heroTitleStart: 'Your move to',
    heroTitleHighlight: 'Frankfurt.',
    heroSubtitle:
      'Compare verified Frankfurt movers for free – from the banking district to Sachsenhausen.',
    heroCtaPrimary: 'Get Free Quotes',
    heroCtaSecondary: 'View Frankfurt Companies',
    heroStatFirms: '160+ Frankfurt companies',
    heroStatMoves: '410+ matched moves',
    heroStatRating: '4.7/5 rating',
    benefitsTitle: 'Your benefits with RegionalUmzug24 in Frankfurt am Main',
    benefitsSubtitle: 'Why Frankfurt customers choose our matching platform',
    benefitFreeTitle: '100% free of charge',
    benefitFreeDesc:
      'Submitting a request and comparing quotes is completely free and non-binding for you.',
    benefitLocalTitle: 'Local Frankfurt companies',
    benefitLocalDesc:
      'We match only verified movers with service in Frankfurt and surroundings (postal codes 60-65).',
    benefitReviewsTitle: 'Real reviews',
    benefitReviewsDesc: 'Read verified customer reviews and decide based on real experiences.',
    statsTitle: 'Moving in Frankfurt in numbers',
    statsSubtitle: 'Frankfurt customers trust RegionalUmzug24',
    statFirms: '160+',
    statFirmsLabel: 'Frankfurt moving companies',
    statMoves: '410+',
    statMovesLabel: 'Matched moves',
    statSavings: '37%',
    statSavingsLabel: 'Avg. savings',
    statRating: '4.7/5',
    statRatingLabel: 'Customer rating',
    processTitle: 'How your Frankfurt move works',
    processSubtitle: 'In three simple steps to your perfect Frankfurt move',
    step1Title: 'Submit a request',
    step1Desc: 'Describe your Frankfurt move in just a few steps online.',
    step2Title: 'Receive Frankfurt quotes',
    step2Desc:
      'Suitable Frankfurt movers send you their offers – including offices in the banking district.',
    step3Title: 'Choose a company',
    step3Desc: 'Compare ratings and choose the best Frankfurt company for your move.',
    trustTitle: 'Verified Frankfurt movers',
    trustSubtitle: 'Safety and quality – tailored to the Main metropolis',
    trustVerifiedTitle: 'Verified Frankfurt companies',
    trustVerifiedDesc:
      'Each mover is checked for business registration, insurance and high-rise experience.',
    trustGdprTitle: 'GDPR compliant',
    trustGdprDesc: 'Your data is transmitted securely and never shared with third parties.',
    trustFreeTitle: '100% free',
    trustFreeDesc: 'Using RegionalUmzug24 is completely free for you – no hidden fees.',
    faqTitle: 'Frequently asked questions about moving in Frankfurt',
    faqSubtitle: 'Answers to the most common questions about moving in Frankfurt',
    faq1Question: 'How much does a move in Frankfurt cost?',
    faq1Answer:
      'The cost of a Frankfurt move depends on apartment size, floor and lift situation. A typical 3-room move within Frankfurt costs between 850 and 1,700 euros.',
    faq2Question: 'How do I find a reliable mover in Frankfurt?',
    faq2Answer:
      'Look for verified reviews, experience with Frankfurt high-rises and proven office logistics.',
    faq3Question: 'Are no-stopping zones arranged in Frankfurt?',
    faq3Answer:
      'Yes, especially in the Westend and banking district, no-stopping zones are often required. Our partners handle the application.',
    faq4Question: 'How long does a move in Frankfurt take?',
    faq4Answer:
      'A typical 3-room Frankfurt move takes five to eight hours depending on floor and traffic.',
    faq5Question: 'Can international moves from Frankfurt be arranged?',
    faq5Answer:
      'Yes, verified Frankfurt movers also offer international moves including customs handling.',
    ctaTitle: 'Ready for your move in Frankfurt?',
    ctaSubtitle: 'Create your free request now and receive quotes from verified Frankfurt movers.',
    ctaPrimary: 'Create Request Now',
    ctaSecondary: 'View Frankfurt Companies',
  },
  frankfurtDirectory: {
    metaTitle: 'Moving Companies Frankfurt | RegionalUmzug24 - Compare Frankfurt Movers',
    metaDescription:
      'List of verified moving companies in Frankfurt am Main. Compare ratings, specialties and prices of Frankfurt movers in postal code areas 60-65.',
    metaKeywords:
      'moving companies Frankfurt, Frankfurt movers, Frankfurt moving company, moving Frankfurt firms',
    pageTitle: 'Moving Companies in Frankfurt am Main',
    pageSubtitle:
      'Discover verified Frankfurt movers with real reviews. Postal code areas 60-65 – from the Westend to Höchst.',
    filterTitle: 'Filters',
    filterPremium: 'Premium companies only',
    filterVerified: 'Verified companies only',
    filterPostalTitle: 'Postal code area',
    filterPostalAll: 'All postal code areas',
    filterPostal60: 'PLZ 60 (city centre)',
    filterPostal65: 'PLZ 65 (west)',
    sortTitle: 'Sort by',
    sortRating: 'Best rating',
    sortOrders: 'Most orders',
    sortNewest: 'Newest',
    resultCount: '{{count}} companies found',
    emptyTitle: 'No companies found',
    emptyDescription: 'No Frankfurt movers match the current filters. Try adjusting the filters.',
    emptyReset: 'Reset filters',
    loadingTitle: 'Loading Frankfurt movers...',
    errorTitle: 'Error loading',
    errorDescription: 'The list of Frankfurt movers could not be loaded. Please try again.',
    errorRetry: 'Retry',
    paginationPrev: 'Previous',
    paginationNext: 'Next',
    paginationPage: 'Page {{page}} of {{total}}',
  },
  stuttgartLanding: {
    metaTitle: 'Moving Stuttgart | RegionalUmzug24 - Compare Stuttgart Movers',
    metaDescription:
      'Find the best moving companies in Stuttgart. Compare free quotes from verified Stuttgart movers experienced with steep streets, the basin and the Filder plain.',
    metaKeywords:
      'moving Stuttgart, moving companies Stuttgart, moving costs Stuttgart, Stuttgart movers',
    heroTitleStart: 'Your move to',
    heroTitleHighlight: 'Stuttgart.',
    heroSubtitle:
      'Compare verified Stuttgart movers for free – experienced with the basin, the Filder plain and Swabia.',
    heroCtaPrimary: 'Get Free Quotes',
    heroCtaSecondary: 'View Stuttgart Companies',
    heroStatFirms: '140+ Stuttgart companies',
    heroStatMoves: '380+ matched moves',
    heroStatRating: '4.7/5 rating',
    benefitsTitle: 'Your benefits with RegionalUmzug24 in Stuttgart',
    benefitsSubtitle: 'Why Stuttgart customers choose our matching platform',
    benefitFreeTitle: '100% free of charge',
    benefitFreeDesc:
      'Submitting a request and comparing quotes is completely free and non-binding for you.',
    benefitLocalTitle: 'Local Stuttgart companies',
    benefitLocalDesc:
      'We match only verified movers with service in Stuttgart and surroundings (postal code area 70).',
    benefitReviewsTitle: 'Real reviews',
    benefitReviewsDesc: 'Read verified customer reviews and decide based on real experiences.',
    statsTitle: 'Moving in Stuttgart in numbers',
    statsSubtitle: 'Stuttgart customers trust RegionalUmzug24',
    statFirms: '140+',
    statFirmsLabel: 'Stuttgart moving companies',
    statMoves: '380+',
    statMovesLabel: 'Matched moves',
    statSavings: '34%',
    statSavingsLabel: 'Avg. savings',
    statRating: '4.7/5',
    statRatingLabel: 'Customer rating',
    processTitle: 'How your Stuttgart move works',
    processSubtitle: 'In three simple steps to your perfect Stuttgart move',
    step1Title: 'Submit a request',
    step1Desc:
      'Describe your Stuttgart move in just a few steps – including steep streets and parking.',
    step2Title: 'Receive Stuttgart quotes',
    step2Desc:
      'Suitable Stuttgart movers send you their offers – including basin-experienced teams.',
    step3Title: 'Choose a company',
    step3Desc: 'Compare ratings and choose the best company for your Stuttgart move.',
    trustTitle: 'Verified Stuttgart movers',
    trustSubtitle: 'Safety and quality – tailored to the Swabian metropolis',
    trustVerifiedTitle: 'Verified Stuttgart companies',
    trustVerifiedDesc:
      'Each mover is checked for business registration, insurance and experience with steep streets.',
    trustGdprTitle: 'GDPR compliant',
    trustGdprDesc: 'Your data is transmitted securely and never shared with third parties.',
    trustFreeTitle: '100% free',
    trustFreeDesc: 'Using RegionalUmzug24 is completely free for you – no hidden fees.',
    faqTitle: 'Frequently asked questions about moving in Stuttgart',
    faqSubtitle: 'Answers to the most common questions about moving in Stuttgart',
    faq1Question: 'How much does a move in Stuttgart cost?',
    faq1Answer:
      'The cost of a Stuttgart move depends on apartment size, street slope and parking situation. A typical 3-room move costs between 800 and 1,600 euros.',
    faq2Question: 'How do I find a reliable mover in Stuttgart?',
    faq2Answer:
      'Look for verified reviews, experience with steep streets in Heslach or Degerloch and knowledge of no-stopping zones.',
    faq3Question: 'Are no-stopping zones arranged in Stuttgart?',
    faq3Answer:
      'Yes, in the basin no-stopping zones are often essential. Our partners handle the application on request.',
    faq4Question: 'How long does a move in Stuttgart take?',
    faq4Answer:
      'A typical 3-room Stuttgart move takes five to eight hours depending on street slope and traffic.',
    faq5Question: 'Can long-distance moves across Swabia be arranged?',
    faq5Answer:
      'Yes, verified Stuttgart movers also offer long-distance moves to all parts of Swabia.',
    ctaTitle: 'Ready for your move in Stuttgart?',
    ctaSubtitle: 'Create your free request now and receive quotes from verified Stuttgart movers.',
    ctaPrimary: 'Create Request Now',
    ctaSecondary: 'View Stuttgart Companies',
  },
  stuttgartDirectory: {
    metaTitle: 'Moving Companies Stuttgart | RegionalUmzug24 - Compare Stuttgart Movers',
    metaDescription:
      'List of verified moving companies in Stuttgart. Compare ratings, specialties and prices of Stuttgart movers in postal code area 70.',
    metaKeywords:
      'moving companies Stuttgart, Stuttgart movers, Stuttgart moving company, moving Stuttgart firms',
    pageTitle: 'Moving Companies in Stuttgart',
    pageSubtitle:
      'Discover verified Stuttgart movers with real reviews. Postal code area 70 – from the basin to the Filder plain.',
    filterTitle: 'Filters',
    filterPremium: 'Premium companies only',
    filterVerified: 'Verified companies only',
    filterPostalTitle: 'Postal code area',
    filterPostalAll: 'All postal code areas',
    filterPostal70: 'PLZ 70 (Stuttgart)',
    sortTitle: 'Sort by',
    sortRating: 'Best rating',
    sortOrders: 'Most orders',
    sortNewest: 'Newest',
    resultCount: '{{count}} companies found',
    emptyTitle: 'No companies found',
    emptyDescription: 'No Stuttgart movers match the current filters. Try adjusting the filters.',
    emptyReset: 'Reset filters',
    loadingTitle: 'Loading Stuttgart movers...',
    errorTitle: 'Error loading',
    errorDescription: 'The list of Stuttgart movers could not be loaded. Please try again.',
    errorRetry: 'Retry',
    paginationPrev: 'Previous',
    paginationNext: 'Next',
    paginationPage: 'Page {{page}} of {{total}}',
  },
  volumeCalculator: {
    title: 'Volume Calculator',
    apartmentType: 'Apartment type',
    rooms: {
      '1': '1-room',
      '2': '2-room',
      '3': '3-room',
      '4': '4-room',
      '5plus': '5+-room',
    },
    livingArea: 'Living area',
    additionalFloors: 'Additional floors (cellar, attic)',
    estimated: 'Estimated moving volume:',
    applyToForm: 'Apply to request',
    toggleAuto: 'Calculate volume automatically',
    toggleManual: 'Enter manually',
    // OPT373 — hardcoded unit/hint strings in VolumeCalculator.tsx
    livingAreaUnit: 'm²',
    floorSurchargeHint: '+5 m³ per floor',
    volumeUnit: 'm³',
  },
  payment: {
    success: {
      metaTitle: 'Payment successful',
      metaDescription: 'The payment process for regionalumzug24 was completed successfully.',
      title: 'Payment successful',
      description:
        'The payment process has been completed. The request will be updated in the company dashboard.',
      paymentIdLabel: 'Payment ID:',
      dashboardButton: 'To Dashboard',
      homeButton: 'Home',
    },
    cancel: {
      metaTitle: 'Payment cancelled',
      metaDescription:
        'The checkout was not completed and can be restarted from the company dashboard.',
      title: 'Payment cancelled',
      description:
        'The checkout was not completed. You can restart the process from the company dashboard.',
      paymentIdLabel: 'Payment ID:',
      dashboardButton: 'Back to Dashboard',
      homeButton: 'Home',
    },
  },
  requestNewForm: {
    moveTypeHeading: 'Move Type',
    moveTypeLabel: 'Type of Move *',
    moveTypePrivate: 'Private Move',
    moveTypeBusiness: 'Business Move',
    moveTypeLongDistance: 'Long Distance Move',
    moveTypeInternational: 'International Move',
    moveTypeSpecial: 'Special Transport',
    tierLabel: 'Request Type *',
    tierStandard: 'Standard (free)',
    tierPremium: 'Premium (paid)',
    tierPremiumPlus: 'Premium+ (paid)',
    tierPaidNotice: '⚠️ Paid service',
    addressesHeading: 'Addresses',
    startAddressLabel: 'Start Address *',
    startPostalCodeLabel: 'Postal Code (Start) *',
    endAddressLabel: 'Destination Address *',
    endPostalCodeLabel: 'Postal Code (Destination) *',
    endPostalCodePlaceholder: 'e.g. 10115',
    detailsHeading: 'Details',
    moveDateLabel: 'Move Date *',
    moveDatePlaceholder: 'Select date',
    volumeLabel: 'Volume (m³)',
    volumePlaceholder: 'e.g. 30',
    volumeHint: 'As a guideline: 1-room ≈ 20m³, 2-room ≈ 35m³, 3-room ≈ 50m³',
    specialHeading: 'Special Requests',
    descriptionLabel: 'Additional Information',
    infoFreeTitle: 'Free & Non-Binding',
    infoFreeDesc: 'Your request is completely free and does not commit you to anything',
    infoGdprTitle: 'GDPR Compliant',
    infoGdprDesc: 'Your data is transmitted securely and encrypted',
    infoFastTitle: 'Fast Responses',
    infoFastDesc: 'Receive offers within 24 hours',
    cancelButton: 'Cancel',
    accountCreatedTitle: 'Account Created',
    accountCreatedDesc:
      'An account has been created automatically for you. Please note your password — it will only be shown once for security reasons.',
    passwordLabel: 'Your Password',
    emailLabel: 'Email:',
    loginButton: 'Understood – to Login',
  },
  requestDetail: {
    caseProfileHeading: 'Case Profile',
    caseProfileCoverage: 'Cost coverage:',
    caseProfileAuthority: 'Authority / Provider:',
    caseProfileReference: 'Reference number:',
    caseProfileContact: 'Contact:',
    caseProfilePhone: 'Phone:',
    caseProfileNote: 'Note:',
    caseProfileEmpty: 'No additional details have been stored for this request yet.',
    checklistHeading: 'Verification Checklist',
    checklistEmpty: 'No expected verifications are currently missing.',
    documentCustomerIdentity: 'ID / Identity verification',
    documentCoverageApproval: 'Cost coverage / Approval',
    documentAuthorityReference: 'Authority document / Reference',
    documentCareLevelProof: 'Care level / Care insurance proof',
    loadErrorTitle: 'Error',
    loadErrorDescription: 'Offers could not be loaded.',
    refreshSuccessTitle: 'Refreshed',
    refreshSuccessDescription: 'Offers have been updated.',
    refreshErrorTitle: 'Error',
    refreshErrorDescription: 'Refresh failed.',
  },
  firmaRequestDetail: {
    caseProfileHeading: 'Case Profile',
    caseProfileCoverage: 'Cost coverage:',
    caseProfileAuthority: 'Authority / Provider:',
    caseProfileReference: 'Reference number:',
    caseProfileNote: 'Note:',
    caseProfileEmpty: 'No additional case details available.',
    customerDocumentsHeading: 'Customer Documents',
    customerDocumentsEmpty: 'No customer documents have been uploaded yet.',
    documentCustomerIdentity: 'ID / Identity verification',
    documentCoverageApproval: 'Cost coverage / Approval',
    documentAuthorityReference: 'Authority document / Reference',
    documentCareLevelProof: 'Care level / Care insurance proof',
  },
  adminLegalContentDialog: {
    savedTitle: 'Saved',
    savedDescription: 'The legal content has been updated.',
    errorTitle: 'Error',
    errorDescription: 'The content could not be saved.',
    dialogTitle: 'Edit Legal Content',
    dialogDescription: 'Edit imprint, privacy policy and terms',
    contentLabelSuffix: ' Content',
    contentPlaceholderPrefix: 'HTML content for ',
    contentPlaceholderSuffix: '...',
    contentHint: 'You may use HTML. The base structure is created automatically.',
    cancelButton: 'Cancel',
    saveButton: 'Save',
    savingButton: 'Saving...',
    tab: {
      impressum: 'Imprint',
      datenschutz: 'Privacy Policy',
      agb: 'Terms & Conditions',
    },
  },
  adminCompanyManagementDialog: {
    editTitle: 'Edit Company',
    newTitle: 'New Company',
    editDescription: 'Update company data',
    newDescription: 'Create a new company',
    userEmailLabel: 'User Email',
    userPasswordLabel: 'User Password',
    nameLabel: 'Company Name',
    emailLabel: 'Company Email',
    phoneLabel: 'Phone',
    descriptionLabel: 'Description',
    statusLabel: 'Status',
    statusPending: 'Pending',
    statusVerified: 'Verified',
    statusRejected: 'Rejected',
    cancelButton: 'Cancel',
    saveButton: 'Save',
    savingButton: 'Saving...',
    updateSuccessTitle: 'Company updated',
    updateSuccessDescription: 'Changes were saved successfully.',
    createSuccessTitle: 'Company created',
    createSuccessDescription: 'The new company was successfully created.',
    userCreateErrorMessage: 'User could not be created.',
    userEmailAlreadyRegistered: 'Email already registered',
    saveErrorTitle: 'Error',
    saveErrorDescription: 'Company could not be saved.',
  },
  compare: {
    metaTitle: 'Compare moving companies | RegionalUmzug24',
    metaDescription:
      'Compare up to 3 verified movers side by side: price, rating, services and availability.',
    title: 'Compare moving companies',
    subtitle: 'Pick up to {{max}} companies and compare them side by side.',
    selectHeading: '{{count}} of {{max}} companies selected',
    tableHeading: 'Comparison details',
    criteria: 'Criterion',
    rating: 'Rating',
    price: 'Price',
    tier: 'Plan',
    services: 'Services',
    serviceArea: 'Service area',
    gallery: 'Gallery',
    noGallery: 'No images available',
    reviews: 'reviews',
    verified: 'Verified',
    premium: 'Premium',
    addToCompare: 'Add to compare',
    removeFromCompare: 'Remove from compare',
    maxThree: 'You can compare up to 3 companies at a time.',
    sendRequestToAll: 'Send request to all {{count}}',
    clearAll: 'Clear comparison',
    emptyTitle: 'No companies selected yet',
    emptyDescription: 'Pick up to 3 movers on the left to compare them in detail.',
    emptyCta: 'Discover companies',
    ctaDescription: 'You have selected {{count}} companies. Send a request to all of them at once.',
    loginRequired: 'Please sign in to send a request.',
    bulkRequestDescription:
      'Comparison request across multiple movers, created from the comparison tool.',
    requestSentTitle: 'Request sent',
    requestSentDescription: 'Your request was sent to {{count}} companies.',
    requestSendError: 'The request could not be sent. Please try again.',
    sending: 'Sending...',
    floatingBar: '{{count}} in comparison',
    openComparison: 'Open comparison',
    bulkDispatchAction: 'Request all {{count}}',
    bulkDispatchSending: 'Sending...',
    bulkDispatchSuccessTitle: 'Request sent',
    bulkDispatchSuccessDescription: 'Request sent to {{count}} companies.',
    bulkDispatchErrorTitle: 'Send failed',
    bulkDispatchErrorDescription: 'The request could not be sent.',
    bulkDispatchLoginRequiredTitle: 'Sign-in required',
    bulkDispatchLoginRequiredDescription: 'Please sign in to send a request.',
    bulkDispatchNoSlugsTitle: 'No bookable companies',
    bulkDispatchNoSlugsDescription: 'At least one company must have a public profile URL.',
    bulkDispatchDefaultAddress: 'To be supplied by customer',
    bulkDispatchSecondaryErrorTitle: 'Request sent, follow-up step failed',
    bulkDispatchSecondaryErrorDescription:
      'The request was sent, but an internal follow-up step failed.',
  },
  packingUpsell: {
    title: 'Add a packing service?',
    subtitle:
      'Save time and protect your belongings. Pick the bundle that fits – companies tailor their offers accordingly.',
    toggleLabel: 'Packing service',
    selected: 'Selected',
    priceLabel: '(surcharge)',
    empty: 'No packing bundles are currently available.',
    loadError: 'The packing bundles could not be loaded.',
    tier: {
      basic: {
        name: 'Basic',
        description: '20 sturdy moving boxes including wrapping paper.',
      },
      standard: {
        name: 'Standard',
        description: '40 boxes, wrapping paper and bubble wrap.',
      },
      premium: {
        name: 'Premium',
        description: 'Unlimited boxes plus a professional packing team for 4 hours.',
      },
    },
  },
  visitScheduler: {
    title: 'Request an on-site visit',
    subtitle:
      'Let the movers assess your belongings in person – free and non-binding (1–2 weeks in advance).',
    dateLabel: 'Preferred date',
    datePlaceholder: 'Select date',
    timeLabel: 'Time',
    timePlaceholder: 'Select time',
    notesLabel: 'Notes (optional)',
    notesPlaceholder: 'e.g. "3rd floor, no elevator"',
    submit: 'Request on-site visit',
    submitting: 'Sending...',
    confirmed: 'Visit confirmed for {{date}}.',
    removeVisit: 'Remove visit',
    errors: {
      missingSelection: 'Please select a date and time.',
      invalidDate: 'The selected date is invalid.',
      generic: 'The visit could not be saved. Please try again.',
    },
  },
  // P3.5 — Insurance partner directory card (EN)
  insurancePartnerCard: {
    featuredBadge: 'Recommended',
    coverageHeading: 'Coverage types',
    coverage: {
      transport: 'Transport insurance',
      liability: 'Liability insurance',
      household: 'Household contents',
      full: 'Full protection',
    },
    websiteLink: 'Visit partner website',
    requestButton: 'Request quote',
    requestingButton: 'Submitting…',
    requestSuccessTitle: 'Request submitted',
    requestSuccessDescription:
      'Your details have been forwarded to {{partner}}. You will hear back shortly.',
    requestErrorTitle: 'Submission failed',
    requestErrorDescription: 'The inquiry could not be submitted. Please try again later.',
    loginRequiredTitle: 'Sign-in required',
    loginRequiredDescription: 'Please sign in to submit an insurance inquiry.',
    consentLabel:
      'I agree that my contact details may be forwarded to the selected insurance partner.',
    descriptionFallback: 'No description available.',
  },
  // P3.3: branch extension v1 — Cleaning landing page (EN)
  cleaningLanding: {
    metaTitle: 'Cleaning | RegionalUmzug24 - Compare cleaning companies',
    metaDescription:
      'Find verified cleaning companies in your region. Compare free quotes for apartment cleaning, office cleaning and move-out cleaning.',
    metaKeywords:
      'cleaning, cleaning company, apartment cleaning, office cleaning, move-out cleaning',
    heroTitleStart: 'Spotlessly clean.',
    heroTitleHighlight: 'Stress-free.',
    heroSubtitle:
      'Compare professional cleaning companies in your region for free. Receive up to 10 quotes and find the perfect cleaning partner.',
    heroCtaPrimary: 'Request cleaning quote',
    heroCtaSecondary: 'Browse cleaners',
    trustBadgeFree: '100% free',
    trustBadgeVerified: 'Verified companies',
    trustBadgeGdpr: 'GDPR compliant',
    benefitsTitle: 'Your benefits with RegionalUmzug24 for cleaning',
    benefitsSubtitle: 'Why our customers choose our cleaning matching platform',
    benefitFreeTitle: '100% free of charge',
    benefitFreeDesc:
      'Creating a request and comparing quotes is completely free and non-binding for you.',
    benefitVettedTitle: 'Vetted cleaners',
    benefitVettedDesc:
      'We match only verified cleaning companies with experience and liability insurance.',
    benefitFastTitle: 'Fast appointments',
    benefitFastDesc: 'Receive quotes within 24 hours and book your preferred slot quickly.',
    statsTitle: 'Cleaning service in numbers',
    statsSubtitle: 'Customers trust RegionalUmzug24',
    statFirms: '150+',
    statFirmsLabel: 'Verified cleaning companies',
    statJobs: '300+',
    statJobsLabel: 'Matched cleanings',
    statRating: '4.8/5',
    statRatingLabel: 'Customer rating',
    servicesTitle: 'Our cleaning services',
    servicesSubtitle: 'What type of cleaning do you need?',
    serviceApartmentTitle: 'Apartment cleaning',
    serviceApartmentDesc: 'Thorough cleaning of your apartment – perfect before or after a move.',
    serviceOfficeTitle: 'Office cleaning',
    serviceOfficeDesc: 'Regular or one-off professional cleaning for your office or practice.',
    serviceMoveOutTitle: 'Move-out cleaning',
    serviceMoveOutDesc:
      'Spotless handover of your old apartment incl. acceptance guarantee with landlord.',
    serviceWindowTitle: 'Window cleaning',
    serviceWindowDesc: 'Streak-free windows, frames and sills – even in hard-to-reach heights.',
    processTitle: 'How it works',
    processSubtitle: 'In only 3 easy steps to the right cleaning company',
    step1Title: 'Submit cleaning request',
    step1Desc: 'Describe your cleaning in a few steps',
    step2Title: 'Receive quotes',
    step2Desc: 'Matching cleaning companies send you their offers',
    step3Title: 'Pick a company',
    step3Desc: 'Compare and pick the best offer',
    ctaTitle: 'Ready for a stress-free cleaning?',
    ctaSubtitle: 'Start now and receive free quotes from verified cleaning companies.',
    ctaPrimary: 'Start cleaning request',
    ctaSecondary: 'Learn more',
    faqTitle: 'Frequently asked questions',
    faqSubtitle: 'Everything you need to know about our cleaning matching',
    faq1Question: 'How much does professional cleaning cost?',
    faq1Answer:
      'Costs depend on size, condition and type of cleaning. Through us you receive free comparable quotes and find the best price.',
    faq2Question: 'Are the cleaning companies insured?',
    faq2Answer:
      'Yes, all matched cleaning companies are vetted and carry liability insurance. You are protected against any damages.',
    faq3Question: 'How fast do I receive quotes?',
    faq3Answer:
      'Typically you receive the first quotes from matching cleaning companies in your region within 24 hours.',
    faq4Question: 'Can I book a cleaning short-term?',
    faq4Answer:
      'Yes, many of our cleaning companies also offer short-term slots. Just specify your preferred date in the request.',
    faq5Question: 'What is included in the price?',
    faq5Answer:
      'Cleaning companies create individual quotes. Usually cleaning supplies, equipment and labour are included. Discuss details directly with the chosen company.',
  },
  // P3.3: branch extension v1 — Disposal landing page (EN)
  disposalLanding: {
    metaTitle: 'Disposal & Clearance | RegionalUmzug24 - Compare clearance companies',
    metaDescription:
      'Find verified disposal and clearance companies in your region. Compare free quotes for apartment clearance, household clearance and bulky waste removal.',
    metaKeywords: 'clearance, disposal, household clearance, apartment clearance, bulky waste',
    heroTitleStart: 'Cleared quickly.',
    heroTitleHighlight: 'Disposed properly.',
    heroSubtitle:
      'Compare professional clearance and disposal companies in your region for free. Receive up to 10 quotes and free up space.',
    heroCtaPrimary: 'Request disposal quote',
    heroCtaSecondary: 'Browse clearance companies',
    trustBadgeFree: '100% free',
    trustBadgeVerified: 'Verified companies',
    trustBadgeGdpr: 'GDPR compliant',
    benefitsTitle: 'Your benefits with RegionalUmzug24 for clearance',
    benefitsSubtitle: 'Why our customers choose our disposal matching platform',
    benefitFreeTitle: '100% free of charge',
    benefitFreeDesc:
      'Creating a request and comparing quotes is completely free and non-binding for you.',
    benefitDisposalTitle: 'Proper disposal',
    benefitDisposalDesc:
      'We match only verified companies with disposal certificates and environmentally sound recycling.',
    benefitFastTitle: 'Fast appointments',
    benefitFastDesc:
      'Receive quotes within 24 hours and book quickly – including short-term slots.',
    statsTitle: 'Disposal service in numbers',
    statsSubtitle: 'Customers trust RegionalUmzug24',
    statFirms: '120+',
    statFirmsLabel: 'Verified clearance companies',
    statJobs: '250+',
    statJobsLabel: 'Matched clearances',
    statRating: '4.7/5',
    statRatingLabel: 'Customer rating',
    servicesTitle: 'Our disposal services',
    servicesSubtitle: 'What type of clearance do you need?',
    serviceApartmentTitle: 'Apartment clearance',
    serviceApartmentDesc: 'Complete or partial clearance of your apartment incl. proper disposal.',
    serviceHouseTitle: 'Household clearance',
    serviceHouseDesc:
      'Clearance of entire households after bereavement, move to care home or divorce – sensitive and discreet.',
    serviceBasementTitle: 'Basement & loft clearance',
    serviceBasementDesc:
      'Finally reclaim space in basement and loft – incl. bulky and hazardous waste removal.',
    serviceGardenTitle: 'Garden clearance',
    serviceGardenDesc:
      'Removal of garden waste, old furniture, construction debris and more – incl. transport.',
    processTitle: 'How it works',
    processSubtitle: 'In only 3 easy steps to the right clearance company',
    step1Title: 'Submit disposal request',
    step1Desc: 'Describe your project in a few steps',
    step2Title: 'Receive quotes',
    step2Desc: 'Matching disposal companies send you their offers',
    step3Title: 'Pick a company',
    step3Desc: 'Compare and pick the best offer',
    ctaTitle: 'Ready for more space?',
    ctaSubtitle: 'Start now and receive free quotes from verified clearance companies.',
    ctaPrimary: 'Start disposal request',
    ctaSecondary: 'Learn more',
    faqTitle: 'Frequently asked questions',
    faqSubtitle: 'Everything you need to know about our clearance matching',
    faq1Question: 'How much does a clearance cost?',
    faq1Answer:
      'Costs depend on volume, floor, effort and disposal type. Through us you receive free comparable quotes.',
    faq2Question: 'Is everything disposed of properly?',
    faq2Answer:
      'Yes, all matched companies are vetted and dispose properly with documentation. Recyclables are recycled, residual waste is properly disposed of.',
    faq3Question: 'How fast can a clearance happen?',
    faq3Answer:
      'Typically you receive the first quotes within 24 hours. Many companies offer appointments within a few days.',
    faq4Question: 'Can I clear only individual rooms?',
    faq4Answer:
      'Yes, you can limit the request to individual rooms, basement or loft – the companies will tailor their offer accordingly.',
    faq5Question: 'What happens to valuable items?',
    faq5Answer:
      'Valuable or re-usable items can be sorted out beforehand. Discuss details directly with the chosen company.',
  },
  // P3.3: branch switcher on the homepage (EN)
  branchSwitcher: {
    title: 'Choose your service',
    subtitle: 'We match verified specialist companies for every task in your region.',
    movingTitle: 'Moving',
    movingDesc: 'Verified moving companies for private and business relocations.',
    cleaningTitle: 'Cleaning',
    cleaningDesc:
      'Professional cleaning companies for apartments, offices and end-of-tenancy cleaning.',
    disposalTitle: 'Clearance',
    disposalDesc: 'Clearance and disposal companies with proper certification.',
    cta: 'Get started',
  },
  // P3.3: admin branch workspace (EN)
  adminBranches: {
    title: 'Branch management',
    subtitle: 'Activate or deactivate branches and monitor their load.',
    loadingError: 'Branches could not be loaded.',
    companiesLabel: 'Companies',
    companiesSupportingLabel: 'supporting this branch',
    requestsAllTimeLabel: 'Requests (all time)',
    requestsLast30Label: 'Requests (30 days)',
    activate: 'Activate',
    deactivate: 'Deactivate',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    loadError: 'Branch statistics could not be loaded.',
    toggleError: 'Status could not be changed.',
    refreshed: 'Branches refreshed.',
  },
  // OPT309 — Company sub-bundles (services + priceTiers extended + pricingSettings + requestTypes + gallery)
  company: {
    services: {
      packing: 'Packing service',
      assembly: 'Furniture assembly',
      disposal: 'Clearance',
      storage: 'Storage',
      piano: 'Piano transport',
      international: 'International',
      renovation: 'Renovation',
      cleaning: 'Cleaning',
      safe_transport: 'Safe transport',
      server_transport: 'Server transport',
      heavy_transport: 'Heavy transport',
      painting_service: 'Painting service',
    },
    priceTiers: {
      standard: 'Standard',
      premium: 'Premium',
      premiumPlus: 'Premium+',
      premiumDesc: 'Premium request: up to 15 qualified offers from verified movers.',
      premiumPlusDesc: 'Premium+ request: up to 5 exclusive offers from top movers.',
    },
    pricingSettings: {
      heading: 'Compensation model',
      subheading:
        'Manage your compensation model (Lead / Commission / Fixed price) and view the related statistics.',
      currentTierLabel: 'Current model',
      noTierLabel: 'No model activated yet',
      activeBadge: 'Active',
      changeButton: 'Change model',
      statsHeading: 'Statistics per model',
      statsRequestsLabel: 'Requests',
      statsRevenueLabel: 'Revenue',
      statsAvgLabel: 'Avg. price',
      statsGrandTotalRequests: 'Total requests',
      statsGrandTotalRevenue: 'Total revenue',
      statsNoData: 'No analytics available yet',
      dialogTitle: 'Choose compensation model',
      dialogDescription:
        'Choose the Lead, Commission or Fixed-price model and enter the corresponding values.',
      closeButton: 'Close',
      loadError: 'The compensation model could not be loaded.',
      loadErrorRetry: 'Retry',
    },
    requestTypes: {
      private: 'Private move',
      business: 'Business move',
      long_distance: 'Long-distance move',
      international: 'International move',
      special: 'Special move',
      official_relocation: 'Official relocation',
      authority_relocation: 'Public authority relocation',
      assisted_move: 'Assisted move (cost coverage)',
    },
    gallery: {
      title: 'Portfolio',
      empty: 'This company has not added any portfolio images yet.',
      upload: 'Upload portfolio images',
      maxPhotos: 'You can manage up to 10 portfolio images.',
      delete: 'Delete image',
      edit: 'Edit portfolio',
    },
  },
};

i18n.addResourceBundle('de', 'translation', deResources, true, true);
i18n.addResourceBundle('en', 'translation', enResources, true, true);

export default i18n;
